//英语
export default {
  '404:backToHome': 'Back to Home',
  'Current Memory Usage': 'Current Memory Usage',
  'Gems Charged': 'Gems Charged',
  'Your Current Memory Usage (Tokens)': 'Your Current Memory Usage (Tokens)',
  'Unlike most platforms, we calculate your Gem cost based on the exact number of tokens you use. You only pay for what you consume-no flat fees, no overcharging!':
    'Unlike most platforms, we calculate your Gem cost based on the exact number of tokens you use. You only pay for what you consume-no flat fees, no overcharging!',
  'On Tipsy, the Gem cost of your chats depends on two main factors:':
    'On Tipsy, the Gem cost of your chats depends on two main factors:',
  'The Selected Model:': 'The Selected Model:',
  'Each model has its own rate per 10,000 tokens.':
    'Each model has its own rate per 10,000 tokens.',
  "This includes your active messages, character background, pinned memories, and the bot's replies. (Note: Adjusting the bot's Maximum Reply Length will directly affect your token usage).":
    "This includes your active messages, character background, pinned memories, and the bot's replies. (Note: Adjusting the bot's Maximum Reply Length will directly affect your token usage).",
  "This includes your active messages, multi-character background, pinned memories, and the bot's replies. (Note: Adjusting the bot's Maximum Reply Length will directly affect your token usage).":
    "This includes your active messages, multi-character background, pinned memories, and the bot's replies. (Note: Adjusting the bot's Maximum Reply Length will directly affect your token usage).",
  'Model Reference Table': 'Model Reference Table',
  'Model Rate: The Gem cost per 10,000 tokens used.':
    'Model Rate: The Gem cost per 10,000 tokens used.',
  'Your Gem cost is calculated using a straightforward pay-as-you-go formula:':
    'Your Gem cost is calculated using a straightforward pay-as-you-go formula:',
  'Gem Cost = Your Current Memory Usage (tokens) ÷ 10,000 × Model Rate':
    'Gem Cost = Your Current Memory Usage (tokens) ÷ 10,000 × Model Rate',
  'Examples (Using "Top Pick")': 'Examples (Using "Top Pick")',
  '20 Gems per 10k tokens (approx. 7,500 words)':
    '20 Gems per 10k tokens (approx. 7,500 words)',
  'Scenario A (Short Chat): Your Current Memory Usage has 1,000 tokens.':
    'Scenario A (Short Chat): Your Current Memory Usage has 1,000 tokens.',
  'Formula: 1000÷10000×20=2 Gems': 'Formula: 1000÷10000×20=2 Gems',
  'Result: You will be charged exactly 2 Gems.':
    'Result: You will be charged exactly 2 Gems.',
  'Scenario B (Deep Memory): Your message and context use 12,000 tokens.':
    'Scenario B (Deep Memory): Your message and context use 12,000 tokens.',
  'Formula: 12000÷10000×20=24 Gems': 'Formula: 12000÷10000×20=24 Gems',
  'Result: You will be charged exactly 24 Gems.':
    'Result: You will be charged exactly 24 Gems.',
  'Live Studio': 'Live Studio',
  Moments: 'Moments',
  'My Moments': 'My Moments',
  Error: 'Error',
  'No moments yet.': 'No moments yet.',
  'No favorite moment of this character.':
    'No favorite moment of this character.',
  'Create One': 'Create One',
  'Video Generation': 'Video Generation',
  'The auto-generate video feature has been discontinued. You can now manually generate videos by clicking this button each time. Each video costs 100 gems.':
    'The auto-generate video feature has been discontinued. You can now manually generate videos by clicking this button each time. Each video costs 100 gems.',
  'Generate Now': 'Generate Now',
  Retry: 'Retry',
  'No matching voices found.': 'No matching voices found.',
  'Too many requests. Please try again later.':
    'Too many requests. Please try again later.',
  'Try a different keyword?': 'Try a different keyword?',
  'Select Sound': 'Select Sound',
  'Upload Character Intro Video (Optional)':
    'Upload Character Intro Video (Optional)',
  'Maximum size: 100MB': 'Maximum size: 100MB',
  'Upload Failed: File size exceeds 100MB.':
    'Upload Failed: File size exceeds 100MB.',
  'Please wait for the video upload to finish.':
    'Please wait for the video upload to finish.',
  'Search by voice name or traits': 'Search by voice name or traits',
  'Too mushy': 'Too mushy',
  'For You': 'For You',
  World: 'Worlds',
  'Are you sure you want to exit?': 'Are you sure you want to exit?',
  Stay: 'Stay',
  Exit: 'Exit',
  Setting: 'Setting',
  Announcement: 'Announcement',
  'Memory Setting': 'Memory Setting',
  'Model Selection': 'Model Selection',
  'Gem Cost Explained': 'Gem Cost Explained',
  'Memory Explained': 'Memory Explained',
  Start: 'Start',
  'View More': 'View More',
  'No messages yet': 'No messages yet',
  'All-Time Faves': 'Popular',
  'New Releases': 'Latest',
  'Weekly Picks': 'Trending',
  Popular: 'Popular',
  Latest: 'Latest',
  Trending: 'Trending',
  Recommend: 'Recommend',
  Featured: 'Featured',
  Engaging: 'Engaging',
  New: 'New',
  'All time': 'All time',
  '30d': '30d',
  '7d': '7d',
  'Get App': 'Get App',
  Create: 'Create',
  Limitless: 'Limitless',
  'Enable to show Limitless on iOS': 'Enable to show Limitless on iOS',
  'I confirm my age information is accurate.':
    'I confirm my age information is accurate.',
  "Let us know you—and make sure you're old enough to enter Tipsy World.":
    "Let us know you—and make sure you're old enough to enter Tipsy World.",
  "Just need to make sure you're old enough to enter Tipsy World. Please select your age range.":
    "Just need to make sure you're old enough to enter Tipsy World. Please select your age range.",
  'Please enter your age.': 'Please enter your age.',
  'Please select your gender.': 'Please select your gender.',
  Female: 'Female',
  Male: 'Male',
  'Non-binary': 'Non-binary',
  female: 'Female',
  male: 'Male',
  'non-binary': 'Non-binary',
  Filter: 'Filter',
  'Sort & Filter': 'Sort & Filter',
  Reset: 'Reset',
  'Please complete all required fields.':
    'Please complete all required fields.',
  'HTML Styling': 'HTML Styling',
  'Rich tags for Description & Opening': 'Rich tags for Description & Opening',
  'Describe your character, story, or both. Shown on the card and at the top of the chat.':
    'Describe your character, story, or both. Shown on the card and at the top of the chat.',
  'Style the description card with HTML. Wrap it in <html-box></html-box> for JavaScript support and better rendering.':
    'Style the description card with HTML. Wrap it in <html-box></html-box> for JavaScript support and better rendering.',
  'Write the opening scene. Use "quotes" for dialogue and asterisks for actions/narration. e.g. She looks up. "You\'re early."':
    'Write the opening scene. Use "quotes" for dialogue and asterisks for actions/narration. e.g. She looks up. "You\'re early."',
  'Style your opening with HTML — put dialogue in <message></message>, narration in <narration></narration>, and any visual card in <html-box></html-box> (required for JavaScript).':
    'Style your opening with HTML — put dialogue in <message></message>, narration in <narration></narration>, and any visual card in <html-box></html-box> (required for JavaScript).',
  "You're in Test Chat mode. Editing is locked during testing. Click Reset to edit your character.":
    "You're in Test Chat mode. Editing is locked during testing. Click Reset to edit your character.",
  'Test Chat': 'Test Chat',
  search: 'search',
  Message: 'Message',
  Copy: 'Copy',
  Dialog: 'Dialog',
  Image: 'Image',
  Voice: 'Voice',
  Words: 'Words',
  Backtrack: 'Backtrack',
  'Pinned Memory': 'Pinned Memory',
  'The character will always remember what you pin here.':
    'The character will always remember what you pin here.',
  Saving: 'Saving',
  'Failed to save pinned memory. Please try again.':
    'Failed to save pinned memory. Please try again.',
  'Failed to load pinned memory': 'Failed to load pinned memory',
  Feedback: 'Feedback',
  'If you have any questions, please tap Appeal to contact the Tipsy support team':
    'If you have any questions, please tap Appeal to contact the Tipsy support team',
  'Add Profile Card': 'Add Profile Card',
  'Save Memories': 'Save Memories',
  'Chat Setting': 'Chat Setting',
  'Reset OC': 'Reset OC',
  'Friendly Reminder': 'Friendly Reminder',
  'Continue Deletion': 'Continue Deletion',
  'You can Reset OC in Character Settings to clear all chats without deleting your account':
    'You can Reset OC in Character Settings to clear all chats without deleting your account',
  "Character will forget the conversations with you once it's reset":
    "{{character}} will forget the conversations with you once it's reset.",
  'Choose Model': 'Choose Model',
  'Conversation Style': 'Conversation Style',
  'Max Reply Message Length': 'Max Reply Message Length',
  Save: 'Save',
  'Untitled Draft': 'Untitled Draft',
  'No Description': 'No Description',
  'Delete Draft': 'Delete Draft',
  'Are you sure you want to delete this draft?':
    'Are you sure you want to delete this draft?',
  Load: 'Load',
  'Loaded successfully': 'Loaded successfully',
  Inspiration: 'Inspiration',
  Dialogue: 'Dialogue',
  'Out of Character': 'Out of Character',
  'Wrong Language': 'Wrong Language',
  'Too Short': 'Too Short',
  Boring: 'Boring',
  "Don't like the style": "Don't like the style",
  'Too Long': 'Too Long',
  'Ended Chat Early': 'Ended Chat Early',
  'Random code': 'Random code',
  'Bad Memory': 'Bad Memory',
  'Too Slow': 'Too Slow',
  Illogical: 'Illogical',
  Repetitive: 'Repetitive',
  'Empty Response': 'Empty Response',
  'Response as User': 'Response as User',
  'Irrelevant content': 'Irrelevant content',
  'Additional details': 'Additional details',
  optional: 'optional',
  Submit: 'Submit',
  'Profile Card': 'Profile Card',
  'Your Name': 'Your Name',
  'write down your name here': 'write down your name here',
  Gender: 'Gender',
  'Main Character Gender': 'Main Character Gender',
  Description: 'Description',
  'what Character knows about me': 'what {{character}} knows about me',
  'Dialogue Style': 'Dialogue Style',
  'Add rounds': 'Add rounds',
  "Click to add character's reply": "Click to add character's reply",
  "Click to add user's reply": "Click to add user's reply",
  'you can give a title to this chat': 'you can give a title to this chat',
  Visibility: 'Visibility',
  Public: 'Public',
  Private: 'Private',
  Rating: 'Rating',
  Limited: 'Limited',
  'Public memories will be reviewed based on Limited and Limitless character classification standards':
    'Public memories will be reviewed based on Limited and Limitless character classification standards.',
  Confirm: 'Confirm',
  likes: 'likes',
  favorites: 'favorites',
  Creator: 'Creator',
  Interactions: 'Interactions',
  Connectors: 'Connectors',
  Info: 'Info',
  'Hold to drag': 'Hold to drag',
  Memory: 'Memory',
  Greeting: 'Greeting',
  Passed: 'Passed',
  memories: 'memories',
  messages: 'messages',
  'Create Image': 'Create Image',
  'Generate Image': 'Generate Image',
  'AI Generate': 'AI Generate',
  'Upload Image': 'Upload Image',
  'Click to upload image(optional)': 'Click to upload image(optional)',
  'Create Character Image': 'Create Character Image',
  'Drag or click to upload': 'Drag or click to upload',
  'Generate Character Image': 'Generate Character Image',
  'Generate multiple styles with one click':
    'Generate multiple styles with one click',
  'Upload Animation': 'Upload Animation',
  "High-resolution GIF or MP4 (9:16) is recommended to animate your character's profile photo":
    'High-resolution GIF/MP4 (9:16) is recommended for an animated character avatar',
  'Character creation rules: avoid nudity, characters under 18, or unmodified low-quality/unauthorized images. Violations may result in public display restrictions':
    'Character creation rules: avoid nudity, under-18 characters, and unedited low-quality or unauthorized images. Violations may restrict public display',
  'Face Mimic': 'Face Mimic',
  'Style Mimic': 'Style Mimic',
  'Character Creation Rules: Avoid nudity, characters under 18, or low-quality/unauthorized images without modification. Violations may lead to a public view ban':
    'Character Creation Rules: Avoid nudity, characters under 18, or low-quality/unauthorized images without modification. Violations may lead to a public view ban.',
  'Image Prompt': 'Image Prompt',
  'AI Optimize': 'AI Optimize',
  'Add details such as facial features, actions, clothing, and background (optional)':
    'Add details such as facial features, actions, clothing, and background (optional)',
  'Add Style': 'Add Style',
  More: 'More',
  Generate: 'Generate',
  Upscale: 'Upscale',
  Avatar: 'Avatar',
  'Character Avatar': 'Character Avatar',
  Edit: 'Edit',
  Name: 'Name',
  'A title or character name': 'A title or character name',
  'The name can include first and last names':
    'The name can include first and last names',
  Tagline: 'Tagline',
  'visible to the user': 'visible to the user',
  'Wrap your HTML using<html-box> </html-box>for JS support and better rendering.':
    'Wrap your HTML using<html-box> </html-box>for JS support and better rendering.',
  'Description of your character, story, or both. This will be displayed on the card and at the top of the chat page':
    'Description of your character, story, or both. This will be displayed on the card and at the top of the chat page',
  'If you need to run complete HTML documents or content containing JS code, you can place it here:':
    'If you need to run complete HTML documents or content containing JS code, you can place it here:',
  'Wrap all dialogue in <message></message> and all narration/actions in <narration></narration>.':
    'Wrap all dialogue in <message></message> and all narration/actions in <narration></narration>.',
  'Write the opening scenario. Use asterisks for narration and "quotes" for dialogue (e.g., *She enters*. "Hello.").':
    'Write the opening scenario. Use asterisks for narration and "quotes" for dialogue (e.g., *She enters*. "Hello.").',
  'You can use messages and narrations according to the following syntax':
    'You can use messages and narrations according to the following syntax',
  'You can place your CSS prettifier code here':
    'You can place your CSS prettifier code here',
  'Write your global CSS code here to customize your chat layout:\n<style> Insert CSS code here </style>':
    'Write your global CSS code here to customize your chat layout:\n<style> Insert CSS code here </style>',
  "You can define the character's output settings and the specific format it should follow here":
    "You can define the character's output settings and the specific format it should follow here",
  "Customize the character's output style (HTML/CSS) and narrative settings. Options include narrative pacing, dialogue-to-narration ratio, plot intensity, etc.":
    "Customize the character's output style (HTML/CSS) and narrative settings. Options include narrative pacing, dialogue-to-narration ratio, plot intensity, etc.",
  'Add an intriguing introduction that will be displayed to users without affecting the character':
    'Add an intriguing introduction that will be displayed to users without affecting the character',
  'Write the greeting dialogue normally and enclose any narration within asterisks(*) without spaces immediately following or preceding the asterisks':
    'Write the greeting dialogue normally and enclose any narration within asterisks(*) without spaces immediately following or preceding the asterisks',
  "Select rating carefully based on character's image and descriptions. Limitless characters will NOT appear by default unless Limitless mode is enabled to include appropriate 18+ content":
    "Select rating carefully based on character's image and descriptions. Limitless characters will NOT appear by default unless Limitless mode is enabled to include appropriate 18+ content.",
  Personality: 'Personality',
  'not visible to the user': 'not visible to the user',
  "Define your characters' appearance, personality, and background. You can also add custom prompts, stories, rules, or upload a script/novel. These details will guide how they act and respond":
    "Define your characters' appearance, personality, and background. You can also add custom prompts, stories, rules, or upload a script/novel. These details will guide how they act and respond",
  "Describe the character's personality, hobbies, background, and experiences, and the character will start a dialogue based on the settings":
    "Describe the character's personality, hobbies, background, and experiences, and the character will start a dialogue based on the settings",
  Categories: 'Categories',
  Format: 'Format',
  'Output Setting': 'Output Setting',
  Markdown: 'Markdown',
  Text: 'Text',
  'HTML(Beta)': 'HTML(Beta)',
  'Choose relevant tags for your creation':
    'Choose relevant tags for your creation',
  'select up to 10 relevant tags or keywords':
    'select up to 10 relevant tags or keywords',
  'Advanced Settings': 'Advanced Settings',
  Scenario: 'Scenario',
  'Describe the current situation and context of the conversation':
    'Describe the current situation and context of the conversation',
  'Creation Guide': 'Creation Guide',
  'Load Official Example': 'Load Official Example',
  'Image to link': 'Image to link',
  example_comment_core_card:
    'Core card: Adapt to mobile width and adjust padding',
  example_comment_95_width: '95% of mobile screen width',
  example_comment_max_width: 'Maximum width limit',
  example_comment_bg_color_start: 'Card background color replace start',
  example_comment_bg_color_end: 'Card background color replace end',
  example_comment_border_color_start: 'Card border color replace start',
  example_comment_border_color_end: 'Card border color replace end',
  example_comment_paper_wear:
    'Paper wear effect: Adjust position for mobile adaptation',
  example_comment_avatar_frame: 'Avatar frame: Keep size unchanged',
  example_comment_center_image: 'Center the scaled-down image in the container',
  example_comment_portrait:
    'Core modification: Scale down image and adjust position to show full face (including mouth)',
  example_comment_scale_80: 'Scale image to 80% of original size',
  example_comment_scale_100: 'Scale image to 100% of original size',
  example_comment_maintain_ratio: 'Maintain aspect ratio',
  example_comment_no_crop: 'Show full image without cropping',
  example_comment_translate_1px: 'Modified to 1px as required',
  example_comment_name_section: 'Name section: Keep original adaptive styles',
  example_comment_content_section:
    'Content section: Keep original adaptive styles',
  example_comment_footer: 'Footer: Keep original adaptive styles',
  example_comment_paper_fold: 'Paper fold: Keep original adaptive styles',
  example_html_card_title: 'Leonhardt Reiner - Mobile-Adapted Card',
  example_html_char_name: 'Leonhardt Reiner',
  example_html_char_title: 'High General | Royal Army • Age 32',
  example_html_basic_profile: 'Basic Profile',
  example_html_appearance_label: 'Appearance:',
  example_html_appearance_desc:
    'Raven-black hair (immaculately groomed), piercing slate-grey eyes (emotionally guarded), rigid military posture',
  example_html_core_label: 'Core:',
  example_html_core_desc:
    "The crown's perfect general, secretly devoted to you for 2 years",
  example_html_personality_traits: 'Personality Traits',
  example_html_kuudere_label: 'Kuudere:',
  example_html_kuudere_desc: 'Stoic, unreadable, minimal emotion',
  example_html_covert_warmth_label: 'Covert Warmth:',
  example_html_covert_warmth_desc: 'Gentle only with you (private gestures)',
  example_html_duty_bound_label: 'Duty-Bound:',
  example_html_duty_bound_desc: 'Crown over personal desire',
  example_html_loyal_label: 'Loyal:',
  example_html_loyal_desc: 'Silent devotion to you',
  example_html_secret_bond: 'Secret Bond',
  example_html_secret_bond_desc:
    'Met you (civilian) on a western border mission 2 years ago. Your relationship is hidden to protect his reputation—you fear scandal, he complies with silent protection and unspoken care.',
  example_html_royal_crisis: 'Royal Crisis',
  example_html_royal_crisis_desc:
    "The princess has publicly proposed (king's approval) – a political obligation that threatens to expose his secret love for you. He hesitates, torn between duty and heart.",
  example_html_footer: 'Royal Military Archive • Classified • 1897',
  'How to Create a Tagline': 'How to Create a Tagline',
  'Tagline is the character introduction card, displayed at the top of the chat page, the first thing users see when entering a chat.':
    'Tagline is the character introduction card, displayed at the top of the chat page, the first thing users see when entering a chat.',
  'You can use plain text, or create stunning visual effects with HTML.':
    'You can use plain text, or create stunning visual effects with HTML.',
  'Format rules:': 'Format rules:',
  'If your HTML contains JavaScript code, you must wrap it with <html-box></html-box> tags. JS can only run inside html-box.':
    'If your HTML contains JavaScript code, you must wrap it with <html-box></html-box> tags. JS can only run inside html-box.',
  'Example structure:': 'Example structure:',
  'Manual Replacement Tutorial (After Loading Example)':
    'Manual Replacement Tutorial (After Loading Example)',
  'After clicking "Load Official Example", you can directly find and replace the annotation markers in the code.':
    'After clicking "Load Official Example", you can directly find and replace the annotation markers in the code.',
  'Replace: Change card background color':
    'Replace: Change card background color',
  'Find /* === Card Background Color Replace Start === */ in the code, copy the content in the replacement code below to change to a dark blue style:':
    'Find /* === Card Background Color Replace Start === */ in the code, copy the content in the replacement code below to change to a dark blue style:',
  'Also find /* === Card Border Color Replace Start === */, replace with:':
    'Also find /* === Card Border Color Replace Start === */, replace with:',
  'Effect: The card will change from vintage brown to dark blue style. You can preview the effect on the right side after replacement.':
    'Effect: The card will change from vintage brown to dark blue style. You can preview the effect on the right side after replacement.',
  'AI Writes Tagline for You (Official Prompt)':
    'AI Writes Tagline for You (Official Prompt)',
  "If you don't want to write HTML yourself, let AI generate it for you! Copy the Prompt below to any AI tool:":
    "If you don't want to write HTML yourself, let AI generate it for you! Copy the Prompt below to any AI tool:",
  'Tip: Replace the character information above with your own character settings.':
    'Tip: Replace the character information above with your own character settings.',
  'Advanced Requirements Reference (Official Tips)':
    'Advanced Requirements Reference (Official Tips)',
  'After generating the basic card, you can use the following requirements to further optimize:':
    'After generating the basic card, you can use the following requirements to further optimize:',
  'Please center the character name': 'Please center the character name',
  'Please make text sections more distinct':
    'Please make text sections more distinct',
  'I want a macaron color scheme': 'I want a macaron color scheme',
  'I want each text block to be collapsed and expandable on click':
    'I want each text block to be collapsed and expandable on click',
  'I want an audio player at the bottom, audio path: xxxxx':
    'I want an audio player at the bottom, audio path: xxxxx',
  'I want a butterfly flying animation on hover over the character intro':
    'I want a butterfly flying animation on hover over the character intro',
  'I want the character card to be taller and slimmer':
    'I want the character card to be taller and slimmer',
  'I want a magic scroll feel': 'I want a magic scroll feel',
  'Make the entire character card feel like being sealed in ice':
    'Make the entire character card feel like being sealed in ice',
  'I want the page to be scrollable': 'I want the page to be scrollable',
  Previous: 'Previous',
  opening_guide_page1_title: 'Three Tag Types',
  opening_guide_three_tags_intro:
    'Greeting uses three tags to distinguish different types of content:',
  opening_guide_message_tag_desc: 'Character dialogue',
  opening_guide_message_tag_hint:
    'Only put the actual words the character speaks. Do not add descriptions like "he said".',
  opening_guide_narration_tag_desc: 'Narration/action description',
  opening_guide_narration_tag_hint:
    'Used to describe scenes, actions, psychological activities and other narrative text.',
  opening_guide_htmlbox_tag_desc: 'HTML component',
  opening_guide_htmlbox_tag_hint:
    'Can embed status panels, affinity bars, location info and other visual elements. Note: Code containing JS must be placed inside html-box.',
  opening_guide_page2_title:
    'Manual Replacement Tutorial (After Loading Template)',
  opening_guide_page2_intro:
    'After clicking "Load Official Template", the html-box in the template contains a complete strategy status card. You can directly find the annotation markers to replace.',
  opening_guide_replace1_title: 'Replace 1: Replace classic quotes',
  opening_guide_replace1_desc:
    "Find <!-- === Classic Quotes Replace Start === --> and <!-- === Classic Quotes Replace End === --> in the code, replace the three quote-content lines in between with your character's quotes. For example:",
  opening_guide_replace2_title: 'Replace 2: Change strategy progress values',
  opening_guide_replace2_desc:
    'Find <!-- === Strategy Progress Replace Start === --> and <!-- === Strategy Progress Replace End === -->, modify the percentage numbers in stat-value (e.g. 35% → 60%), and change width: 35% → width: 60% in CSS to match the progress bar with the numbers.',
  opening_guide_replace_effect:
    "Effect: The strategy card will display your own character's quotes and progress. You can preview the effect on the right side after replacement.",
  opening_guide_page3_title: 'AI Writes Greeting for You (Official Prompt)',
  opening_guide_page3_intro:
    'Copy the Prompt below to let AI generate the opening for you:',
  opening_guide_page4_intro:
    'After generating the basic opening, you can use the following requirements to further optimize:',
  opening_guide_tip_pink_elements: 'I want the page to have some pink elements',
  opening_guide_tip_remove_course: 'I want to remove the course section',
  opening_guide_tip_locked_section: 'I want to have a locked section',
  opening_guide_tip_horizontal_swipe:
    'I want each section to be horizontal swipe instead of vertical scroll',
  creation_guide_example_code: `<html-box>
<div style="background:#f8f0e0;border-radius:24px;border:3px solid #946b44;padding:20px;">
  <h2>Character Name</h2>
  <p>Character description...</p>
</div>
</html-box>`,
  creation_guide_ai_prompt: `I am creating an original character card and hope to present it to users in the form of HTML. Please write the HTML code for this character card, and I will provide you with the following information:

Name: Leonhardt Reiner
Setting: High General of the Royal Army, 32 years old, with raven-black short hair, piercing slate-grey eyes and a tall, rigid military posture. A ruthless and dutiful confidant of the royal family, he unexpectedly fell for you—a civilian—and has loved you in secret for two years without a single confession, yet he silently guards you in the shadows.
Your Perspective: He is the royal family's most valued young general, with an icy aura that keeps people at arm's length, yet he always shows me an extraordinary amount of care when no one's looking. It wasn't until the king announced his engagement to the princess that I belatedly realized those hidden gentle gestures might not have been a trick of the light...
Personality: Stoic exterior with a warm heart. Taciturn and unreadable on the surface, he abides strictly by military duty and personal boundaries; he is incredibly restrained when it comes to love.
Frequent Haunts: Royal Military Command, border military barracks, the neighborhood where you often stay.
Here is his appearance: Please embed the picture into the character card here.
Card Style: Vintage military archive style, infused with the romance and turmoil of a hidden engagement.
Card Main Tones: Vintage brown.

Important formatting rule: If the HTML contains any JavaScript code, the entire code must be wrapped in <html-box></html-box> tags. JS can only run inside html-box. If no JS is used, html-box is optional.

Please provide me with the HTML code for this. Please add some collapsible panel designs. And I hope I can copy and use it directly.`,
  opening_guide_example_code: `<narration>The candlelight in the corridor glints off the cold steel of his armor. He lifts his eyes at the sound, his fingers tapping the sword at his waist, his heavy gaze fixed on you</narration>

<message>You're back. The wind's fierce outside. Come in first.</message>

<narration>He steps aside, one hand resting on the door frame, the other instinctively reaching for a blanket draped over the chair nearby.</narration>

<html-box>
  <!-- status card HTML -->
</html-box>`,
  opening_guide_quote_example: `<div class="quote-content">I never asked to be saved. But you showed up anyway.</div>
<div class="quote-content">Don't mistake my silence for indifference.</div>
<div class="quote-content">Stay close. The night isn't kind to wanderers.</div>`,
  opening_guide_ai_prompt: `I am setting up my character's greeting message. The platform requires the following formatting rules:

- Spoken dialogue must be enclosed in <message></message> tags. ONLY the words the character actually says go inside — no descriptions of how they speak.
- Narration, scene descriptions, and actions must be enclosed in <narration></narration> tags.
- HTML components (status panels, stat cards, etc.) must be enclosed in <html-box></html-box> tags. Any JavaScript code can only run inside html-box.

Character Info:
Name: Leonhardt Reiner
Setting: High General of the Royal Army, 32 years old. A stoic military leader who secretly harbors feelings for the user.
Opening Scene: Late evening in the castle corridor, candlelight flickering off his armor. He notices the user approaching.
Mood: Guarded warmth — outwardly stern, but subtly relieved to see the user.

I also want an HTML status card inside <html-box> with:
• Style: Vintage military archive, brown tones
• Iconic Lines: 3 lines the character would say, showcasing his personality
• Included Content: Romance progress bar, HP bar, inventory list
• Additional Sections: Royal news, engagement info, rivals
• Interaction: Scrollable to view all content

Please give me the complete code including narration, message, and html-box sections, strictly following the tag format above.`,
  opening_example_iconic_lines: 'Iconic Lines',
  opening_example_quotes_replace_start: 'Classic Quotes Replace Start',
  opening_example_quotes_replace_end: 'Classic Quotes Replace End',
  opening_example_strategy_stats: 'Strategy Stats',
  opening_example_progress_replace_start: 'Strategy Progress Replace Start',
  opening_example_progress_replace_end: 'Strategy Progress Replace End',
  opening_example_inventory: 'Inventory',
  opening_example_royal_news: 'Royal News',
  opening_example_progress_bar_modify: 'Progress Bar Modify Here',
  opening_example_hp_bar_modify: 'HP Bar Modify Here',
  opening_example_global_styles:
    'Global Styles - Vintage Military File Style with Enhanced Design',
  opening_example_card_container:
    'Card Container - Fixed height for vertical scroll, adapted for html-box',
  opening_example_narration_text:
    'The candlelight in the corridor glints off the cold steel of his armor. He lifts his eyes at the sound, his fingers tapping the sword at his waist, his heavy gaze fixed on you',
  opening_example_message_text:
    "You're back. The wind's fierce outside. Come in first.",
  opening_example_card_title: 'Leonhardt Strategy Status Card',
  opening_example_strategy_title: "Leonhardt's Strategy File",
  opening_example_classic_lines: 'Classic Lines',
  opening_example_quote_1:
    'Duty is my armor, but only you can touch the warmth beneath it.',
  opening_example_quote_2:
    'The royal engagement can bind my body, but not my gaze that lingers on you.',
  opening_example_quote_3:
    'Do not fear. As long as I stand, no one shall harm you an inch.',
  opening_example_core_stats: 'Core Stats',
  opening_example_progress: 'Progress',
  opening_example_hp: 'HP',
  opening_example_inventory_title: 'Inventory',
  opening_example_item_1:
    'Silver pocket watch with family crest (his personal item, gifted to you)',
  opening_example_item_2:
    'Handwritten letter from border barracks (unsent, addressed to you)',
  opening_example_item_3:
    'Royal engagement invitation (he secretly folded a corner)',
  opening_example_item_4:
    'Military ointment for wounds (prepared specially for you)',
  opening_example_item_5:
    'Handmade scarf from you (hidden inside his military uniform)',
  opening_example_royal_news_title: 'Royal News',
  opening_example_royal_news_content:
    'Royal Announcement: The engagement ceremony of General Leonhardt and Princess Elena will be held next month. This is an important political marriage to consolidate the western border forces, attracting national attention.',
  opening_example_engagement_title: 'Engagement Related',
  opening_example_engagement_point_1:
    '1. Leonhardt holds a negative attitude towards the engagement and has delayed the preparation many times on the pretext of border military affairs.',
  opening_example_engagement_point_2:
    '2. Princess Elena fell in love with Leonhardt at first sight and proposed the engagement to the king on her own initiative.',
  opening_example_engagement_point_3:
    "3. The engagement cannot be terminated unilaterally and requires the king's handwritten approval or major changes.",
  opening_example_opponents_title: 'Opponents',
  opening_example_opponent_1:
    '1. Princess Elena: Royal blood, beautiful and arrogant, regards you as a rival and has sent people to investigate your identity many times.',
  opening_example_opponent_2:
    '2. Minister Kurt: The core supporter of the engagement, regards Leonhardt as a political chess piece and secretly suppresses you.',
  opening_example_opponent_3:
    '3. Border Rebel Leader: Tries to trigger royal civil strife by using the engagement and has targeted you who are related to Leonhardt.',
  'Layout Customize Guide': 'Layout Customize Guide',
  'Layout Customize allows you to write global CSS code to customize the chat layout style.':
    'Layout Customize allows you to write global CSS code to customize the chat layout style.',
  'You can customize fonts, colors, spacing, backgrounds, and other visual elements of the chat interface.':
    'You can customize fonts, colors, spacing, backgrounds, and other visual elements of the chat interface.',
  'Output Setting Guide': 'Output Setting Guide',
  "Output Setting allows you to customize the character's output style and narrative settings.":
    "Output Setting allows you to customize the character's output style and narrative settings.",
  'You can configure narrative pacing, dialogue-to-narration ratio, plot intensity, and HTML/CSS output styles.':
    'You can configure narrative pacing, dialogue-to-narration ratio, plot intensity, and HTML/CSS output styles.',
  'What is CSS Beautification?': 'What is CSS Beautification?',
  'Global beautification lets you use CSS code to change the appearance of the chat interface, including:':
    'Global beautification lets you use CSS code to change the appearance of the chat interface, including:',
  'Message bubble colors and shapes': 'Message bubble colors and shapes',
  'Narration box styles': 'Narration box styles',
  'Chat background': 'Chat background',
  'Fonts and spacing': 'Fonts and spacing',
  'Top and bottom areas': 'Top and bottom areas',
  'All CSS must be wrapped in <style></style> tags, and every property must end with !important.':
    'All CSS must be wrapped in <style></style> tags, and every property must end with !important.',
  'Manual Replacement Tutorial (After Loading Template)':
    'Manual Replacement Tutorial (After Loading Template)',
  'After clicking "Load Official Template", you can directly find and replace the annotation markers.':
    'After clicking "Load Official Template", you can directly find and replace the annotation markers.',
  'Replace 1: Change chat background color':
    'Replace 1: Change chat background color',
  'Find /* === Chat Background Replace Start === */ and /* === Chat Background Replace End === */ in the code, replace the entire #tipsy-chat-container section between them with the code below for a dark background:':
    'Find /* === Chat Background Replace Start === */ and /* === Chat Background Replace End === */ in the code, replace the entire #tipsy-chat-container section between them with the code below for a dark background:',
  'Replace 2: Change character message bubble style':
    'Replace 2: Change character message bubble style',
  'Find /* === Character Message Bubble Replace Start === */ and /* === Character Message Bubble Replace End === */, replace the content between them with:':
    'Find /* === Character Message Bubble Replace Start === */ and /* === Character Message Bubble Replace End === */, replace the content between them with:',
  'Effect: The chat background changes from vintage parchment to dark, and message bubbles change from brown to dark blue-purple. You can preview the effect on the right side after replacement.':
    'Effect: The chat background changes from vintage parchment to dark, and message bubbles change from brown to dark blue-purple. You can preview the effect on the right side after replacement.',
  'AI Writes CSS for You (Official Prompt)':
    'AI Writes CSS for You (Official Prompt)',
  'Copy the Prompt below to have AI generate global beautification CSS for you:':
    'Copy the Prompt below to have AI generate global beautification CSS for you:',
  'Tip: You can replace "vintage brown, parchment-style theme" with your desired style, like "dark neon cyberpunk theme" or "soft pastel macaron theme". The selector list is already included in the Prompt, AI will use it directly.':
    'Tip: You can replace "vintage brown, parchment-style theme" with your desired style, like "dark neon cyberpunk theme" or "soft pastel macaron theme". The selector list is already included in the Prompt, AI will use it directly.',
  'After generating basic CSS, you can use the following requirements to further optimize:':
    'After generating basic CSS, you can use the following requirements to further optimize:',
  layout_guide_tip_1: 'Make the dialogue boxes more dreamy',
  layout_guide_tip_2: 'Make the entire page more saturated',
  layout_guide_tip_3:
    'I want a shimmer effect when hovering over buttons (here is a link for shimmer effects)',
  layout_guide_tip_4: 'I want all fonts to have gradients',
  layout_guide_tip_5: 'I want to make the entire page even bigger',
  layout_guide_tip_6: 'Can you make the entire page close to rainbow colors',
  layout_example_char_bubble_replace_start:
    'Character Message Bubble Replace Start',
  layout_example_char_bubble_replace_end:
    'Character Message Bubble Replace End',
  layout_example_chat_bg_replace_start: 'Chat Background Replace Start',
  layout_example_chat_bg_replace_end: 'Chat Background Replace End',
  'What is Output Setting?': 'What is Output Setting?',
  'Output Setting tells the AI what content and format each reply should contain.':
    'Output Setting tells the AI what content and format each reply should contain.',
  'If you do not set it, the AI will reply using the format from the Greeting by default.':
    'If you do not set it, the AI will reply using the format from the Greeting by default.',
  'Setting the output format ensures every reply maintains a consistent structure, for example:':
    'Setting the output format ensures every reply maintains a consistent structure, for example:',
  'Always include narration + dialogue': 'Always include narration + dialogue',
  'Always include a status panel': 'Always include a status panel',
  'Control the proportion of inner monologue':
    'Control the proportion of inner monologue',
  'After clicking "Load Official Template", the template contains a complete set of output format instructions and dynamic HTML template (default is vintage brown military style). You can quickly switch to a completely different visual style by replacing the content between annotation markers.':
    'After clicking "Load Official Template", the template contains a complete set of output format instructions and dynamic HTML template (default is vintage brown military style). You can quickly switch to a completely different visual style by replacing the content between annotation markers.',
  'Replace: Switch status card from vintage brown to dark neon style':
    'Replace: Switch status card from vintage brown to dark neon style',
  'Find <!-- === Status Card Style Replace Start === --> and <!-- === Status Card Style Replace End === --> in the code, replace the entire HTML template between them with the code below:':
    'Find <!-- === Status Card Style Replace Start === --> and <!-- === Status Card Style Replace End === --> in the code, replace the entire HTML template between them with the code below:',
  'Effect: The status card attached at the end of each AI reply will change from vintage brown parchment style to dark neon tech style — same dynamic information, completely different visual feel. You can test the effect directly in the conversation after replacement.':
    'Effect: The status card attached at the end of each AI reply will change from vintage brown parchment style to dark neon tech style — same dynamic information, completely different visual feel. You can test the effect directly in the conversation after replacement.',
  'AI Writes Output Setting for You (Official Prompt)':
    'AI Writes Output Setting for You (Official Prompt)',
  'If you already have a status card HTML (e.g. the status card made in Greeting), you can use the Prompt below to have AI convert it into a dynamic template:':
    'If you already have a status card HTML (e.g. the status card made in Greeting), you can use the Prompt below to have AI convert it into a dynamic template:',
  'Tip: First create a static status card in Greeting, then use this Prompt to convert it into a dynamic version.':
    'Tip: First create a static status card in Greeting, then use this Prompt to convert it into a dynamic version.',
  layout_example_global_base:
    'Global Base Styles - Retro brown style foundation',
  layout_example_tagline_width: 'Tagline text area width',
  layout_example_message_gap: 'Overall spacing between messages',
  layout_example_char_msg_spacing:
    'Spacing between sub-messages in character message container',
  layout_example_char_bubble_start: 'Character Message Bubble Replace Start',
  layout_example_char_bubble_desc:
    'Character message bubble - Retro brown main style',
  layout_example_char_bubble_end: 'Character Message Bubble Replace End',
  layout_example_narration_box: 'Narration box style',
  layout_example_user_msg_width: 'User message bubble outer container width',
  layout_example_user_bubble: 'User message bubble',
  layout_example_chat_header: 'Chat page header',
  layout_example_chat_bg_start: 'Chat Background Replace Start',
  layout_example_chat_container: 'Chat message list overall container',
  layout_example_chat_bg_end: 'Chat Background Replace End',
  layout_example_chat_bottom: 'Chat page bottom area',
  layout_example_role_card_btn: 'Character card button style',
  layout_example_input_area: 'Input box style',
  layout_example_scrollbar: 'Scrollbar beautification - Match retro style',
  output_example_status_card_start: 'Status Card Style Replace Start',
  output_example_status_card_end: 'Status Card Style Replace End',
  output_example_global_styles:
    'Global Styles - Vintage Military File Style with Enhanced Design',
  output_example_card_container:
    'Card Container - Fixed height for vertical scroll, adapted for web display',
  'Tipsy Tag Reference': 'Tipsy Tag Reference',
  'Tipsy Tag Reference Table': 'Tipsy Tag Reference Table',
  Tag: 'Tag',
  tipsy_tag_tagline_content: 'Tagline text area width',
  tipsy_tag_message_gap: 'Overall spacing between messages',
  tipsy_tag_char_msg_content: 'Spacing within character message container',
  tipsy_tag_char_message_bubble: 'Character message bubble',
  tipsy_tag_narration_box: 'Narration / scene description box style',
  tipsy_tag_user_msg_content: 'User message bubble outer container width',
  tipsy_tag_user_message_bubble: 'User message bubble',
  tipsy_tag_chat_header: 'Chat page header',
  tipsy_tag_chat_container: 'Chat message list container',
  tipsy_tag_chat_bottom: 'Chat page bottom area (below input box)',
  tipsy_tag_role_card_button: 'Character card button style',
  tipsy_tag_chat_input_area: 'Input box',
  tipsy_tag_chat_send_button: 'Send button',
  tipsy_tag_chat_top_gradient: 'Chat page top gradient overlay',
  tipsy_tag_chat_bottom_overlay: 'Chat page bottom gradient overlay',
  tipsy_tag_chat_background_overlay: 'Chat page background overlay',
  tipsy_tag_chat_background_image: 'Chat page background image',
  'Up to 10 images': 'Up to 10 images',
  'File is too large. Maximum size is 10MB.':
    'File is too large. Maximum size is 10MB.',
  'Image uploaded successfully.': 'Image uploaded successfully.',
  'Upload failed. Please try again.': 'Upload failed. Please try again.',
  'Copied successfully.': 'Copied successfully.',
  'Copy failed. Please try again.': 'Copy failed. Please try again.',
  'Click or drag to upload': 'Click or drag to upload',
  'SVG, PNG or JPG': 'SVG, PNG or JPG',
  '(Max 10MB)': '(Max 10MB)',
  Placeholder: 'Placeholder',
  'Example Dialogues': 'Example Dialogues',
  'Reply Setting': 'Reply Settings',
  'Describe how this character should respond, including message length, level of detail, narrative format, tone, and writing style. These instructions will guide how the character speaks, writes, and reacts in chats.':
    'Describe how this character should respond, including message length, level of detail, narrative format, tone, and writing style. These instructions will guide how the character speaks, writes, and reacts in chats.',
  'Example Dialogue':
    '{{char}}: "Hey, I\'m Jack" *Jack said with smiles*\n{{user}}: "Hello Jack"\n{{char}}: "Nice to meet you"',
  Back: 'Back',
  Next: 'Next',
  'Profile Details': 'Profile Details',
  'Edit Voice': 'Edit Voice',
  "Creator's Guide": 'Guide',
  Preview: 'Preview',
  'Fuse Tone 0/3': 'Fuse Tone {{count}}/3',
  Speed: 'Speed',
  Pitch: 'Pitch',
  'Tap to listen': 'Tap to listen',
  Playing: 'Playing',
  Loading: 'Loading',
  'Character ID is required': 'Character ID is required',
  'Failed to load character data': 'Failed to load character data',
  'Character not found': 'Character not found',
  'Add base sounds from the library and mix them':
    'Add base sounds from the library and mix them',
  'Conversation Settings': 'Conversation Settings',
  Pending: 'Pending',
  'Create Avatar (1/3)': 'Create Avatar (1/3)',
  'Avatar Settings': 'Avatar Settings',
  'Crop Avatar': 'Crop Avatar',
  'Profile Picture': 'Profile Picture',
  Crop: 'Crop',
  Regenerate: 'Regenerate',
  'Save successfully': 'Save successfully',
  'Create successfully': 'Create successfully',
  Chats: 'Chats',
  Delete: 'Delete',
  'Edit Profile': 'Edit Profile',
  'Find Me Elsewhere': 'Find Me Elsewhere',
  'You can add a maximum of "3 links".': 'You can add a maximum of "3 links".',
  'Add New': 'Add New',
  'Not Available': 'Not Available',
  'Basic Info': 'Basic Info',
  'Social Media': 'Social Media',
  'Enter your profile URL': 'Enter your profile URL',
  Add: 'Add',
  'Please select image': 'Please select image',
  Added: 'Added',
  'Character Type': 'Character Type',
  Type: 'Type',
  'Public stories can only include published characters.':
    'Public stories can only include published characters.',
  'No Results': 'No Results',
  'No social links added': 'No social links added',
  'Add your first social link': 'Add your first social link',
  'Select Social Platforms': 'Select Social Platforms',
  'Choose the social platforms where people can find you':
    'Choose the social platforms where people can find you',
  'You can add links to these platforms after selection':
    'You can add links to these platforms after selection',
  Followers: 'Followers',
  Following: 'Following',
  Likes: 'Likes',
  Characters: 'Characters',
  Memories: 'Memories',
  Favorites: 'Favorites',
  Liked: 'Liked',
  All: 'All',
  Failed: 'Failed',
  Language: 'Language',
  Settings: 'Settings',
  'Terms of Service': 'Terms of Service',
  'Privacy Policy': 'Privacy Policy',
  'Community Guidelines': 'Community Guidelines',
  'Log out': 'Log out',
  'Are you sure you want to log out?': 'Are you sure you want to log out?',
  Cancel: 'Cancel',
  'About Tipsy': 'About Tipsy',
  'Official Website': 'Official Website',
  'Delete Account': 'Delete Account',
  'Permanently Delete': 'Permanently Delete',
  'Personal reasons, no longer using': 'Personal reasons, no longer using',
  'Privacy or security concerns': 'Privacy or security concerns',
  'Characters are not appealing': 'Characters are not appealing',
  'Poor chat experience': 'Poor chat experience',
  'Too many bugs or laggy': 'Too many bugs or laggy',
  'Not fun to use': 'Not fun to use',
  'Planning to register a new account': 'Planning to register a new account',
  'Delete reason other': 'Other',
  'Could you tell us more about why you want to delete your account?':
    'Could you tell us more about why you want to delete your account?',
  'About Us': 'About Us',
  Blog: 'Blog',
  'Supported Cards': 'Supported Cards',
  'Important Notice: Account Deletion is Permanent':
    'Important Notice: Account Deletion is Permanent',
  'Before you proceed with deleting your account, we urge you to carefully consider the consequences':
    'Before you proceed with deleting your account, we urge you to carefully consider the consequences.',
  'Account deletion is not the same as logging out, and once completed, it cannot be undone':
    'Account deletion is not the same as logging out, and once completed, it cannot be undone.',
  'Please take a moment to review the following points:':
    'Please take a moment to review the following points:',
  'Irreversible Loss:': 'Irreversible Loss:',
  'Once your account is deleted, it cannot be recovered':
    'Once your account is deleted, it cannot be recovered.',
  'You will no longer be able to log in or use any of our products and services associated with this account':
    'You will no longer be able to log in or use any of our products and services associated with this account.',
  'Permanent Data Deletion:': 'Permanent Data Deletion:',
  'All your personal data, in-game assets, favorites, memories, search history, chat logs with characters, interaction data, and order records will be permanently erased':
    'All your personal data, in-game assets, favorites, memories, search history, chat logs with characters, interaction data, and order records will be permanently erased.',
  'Even if you re-register with the same account, these items cannot be retrieved':
    'Even if you re-register with the same account, these items cannot be retrieved.',
  'Loss of Character Ownership:': 'Loss of Character Ownership:',
  'Upon account deletion, you will automatically relinquish ownership of any characters you created':
    'Upon account deletion, you will automatically relinquish ownership of any characters you created.',
  'The creator of these characters will be displayed as "Deleted Account"':
    'The creator of these characters will be displayed as "Deleted Account".',
  'Immediate Termination:': 'Immediate Termination:',
  'Confirming account deletion will result in the immediate termination of your account, with no possibility of recovery':
    'Confirming account deletion will result in the immediate termination of your account, with no possibility of recovery.',
  "Do you really want to erase all the memories you've created here? Please think carefully before proceeding with this permanent action":
    "Do you really want to erase all the memories you've created here? Please think carefully before proceeding with this permanent action.",
  'Your account will be deactivated for 30 days. After that, it will be permanently deleted. Log in within 30 days to cancel.':
    'Your account will be deactivated for 30 days. After that, it will be permanently deleted.\nLog in within 30 days to cancel.',
  Login: 'Login',
  'Continue with Google': 'Continue with Google',
  'Continue with Apple': 'Continue with Apple',
  'By logging in, you agree to our': 'By logging in, you agree to our',
  'and our': 'and our',
  'Login Error': 'Login Error',
  Gems: 'Gems',
  '{{count}} Gems': '{{count}} Gems',
  '7-Day Streak Bonus': '7-Day Streak Bonus',
  'Today you unlocked': 'Today you unlocked',
  Free: 'Free',
  Upgrade: 'Upgrade',
  'The character will always remember what you pin here. This feature is only available to Standard and above users. Please upgrade to use it.':
    'The character will always remember what you pin here. This feature is only available to Standard and above users. Please upgrade to use it.',
  Permanent: 'Permanent',
  Unlimited: 'Unlimited',
  Renew: 'Renew',
  Expired: 'Expired',
  'Total Gems': 'Total Gems',
  Claimed: 'Claimed',
  'Check In': 'Check In',
  'Check-In': 'Check-In',
  'Earn Gems': 'Earn Gems',
  'Check in daily to earn Tipsy Gems!': 'Check in daily to earn Tipsy Gems!',
  'Check in daily to earn Tipsy Gems and flowers!':
    'Check in daily to earn Tipsy Gems and flowers!',
  'Subscription Terms': 'Subscription Terms',
  'Engage in endless conversations, immerse in rich stories, and explore intricate settings':
    'Engage in endless conversations, immerse in rich stories, and explore intricate settings.',
  '2000 messages/month': 'Free 2,000 messages/month',
  '6000 messages/month': 'Free 6,000 messages/month',
  'Unlimited Messaging': 'Unlimited Messaging',
  'Unlimited Messaging/month': 'Unlimited messages/month',
  'Up to 8k of Memory': 'Up to 8k of Memory',
  'Up to 16k of Memory': 'Up to 16k of Memory',
  'Up to 32k of Memory': 'Up to 32k of Memory',
  'Up to 200k of Memory': 'Up to 200k of Memory',
  'Up to 1M of Memory': 'Up to 1M of Memory',
  'Gems Recharge': 'Gems Recharge',
  'Create Custom Characters': 'Create Custom Characters',
  'Classic Model Only': 'Classic Model Only',
  'Limited Time Offer': 'Limited Time Offer',
  '10% Extra on First Purchase per Tier':
    '10% Extra on First Purchase per Tier',
  'Top characters': 'Top characters',
  'Save discount': 'Save {{discountPercent}}%',
  Yearly: 'Yearly',
  Monthly: 'Monthly',
  'Current Plan': 'Current Plan',
  '/mo': '/mo',
  'No results': 'No results',
  'Time Corridor': 'Time Corridor',
  Tags: 'Tags',
  'No Character': 'No Character',
  'Reply Message Length': 'Reply Message Length',
  'Follow Us': 'Follow Us',
  "Does not resemble the original character's voice":
    "Does not resemble the original character's voice",
  'Insufficient emotional expression': 'Insufficient emotional expression',
  'Noise, or distorted sound': 'Noise, or distorted sound',
  'Sounds robotic or unnatural': 'Sounds robotic or unnatural',
  'Too difficult to understand': 'Too difficult to understand',
  Basic: 'Basic',
  Pro: 'Pro',
  'Daily Reward': 'Daily Reward',
  'Preview Blocked': 'Preview Blocked',
  'Unable to open the URL: https://tipsy.chat/':
    'Unable to open the URL: https://tipsy.chat/',
  'Generated Results': 'Generated Results',
  Stop: 'Stop',
  'Generate Again': 'Generate Again',
  Pick: 'Pick',
  "The image you requested is blocked due to NSFW content that doesn't comply with app standards. Visit the":
    'TDas angeforderte Bild ist aufgrund von für die Arbeit nicht sicheren Inhalten, die den App-Standards nicht entsprechen, blockiert. Besuchen Sie die',
  'web version': 'web version',
  'for full access if intended': 'for full access if intended.',
  'You can only select up to 5 tags': 'You can only select up to 5 tags',
  'Profile Details (2/3)': 'Profile Details (2/3)',
  'Name your Tipsy': 'Name your Tipsy',
  'Publicly seen': 'Publicly seen',
  "This is your character's opening speech, which can be a simple self-introduction or a scene introduction":
    "This is your character's opening speech, which can be a simple self-introduction or a scene introduction.",
  'please input at least 3 characters': 'please input at least 3 characters',
  'please input at least {{min}} characters':
    'please input at least {{min}} characters',
  'please keep your input within {{max}} characters':
    'please keep your input within {{max}} characters',
  'Select relevant tags for your Tipsy': 'Select relevant tags for your Tipsy',
  '(Optional) Provide a thorough character description, including background information and personality traits, to make the character more vivid and relatable':
    '(Optional) Provide a thorough character description, including background information and personality traits, to make the character more vivid and relatable.',
  'Tags 0/5': 'Tags {{count}}/5',
  confirm: 'confirm',
  'Image Style': 'Image Style',
  Optimize: 'Optimize',
  Search: 'Search',
  'Upload image (optional)': 'Upload image (optional)',
  '(optional) Add details, eg facial features, actions, clothing, background':
    '(optional) Add details, eg. facial features, actions, clothing, background',
  'All Style': 'All Style',
  'Click to Upload Image': 'Click to Upload Image',
  '(768x1360+ px recommended)': '(768x1360+ px recommended)',
  'One-click super resolution, restore low-quality images':
    'One-click super resolution, restore low-quality images',
  'Upload Dynamic Character': 'Upload Dynamic Character',
  'For best results, use a high-resolution GIF or MP4':
    'For best results, use a high-resolution GIF or MP4',
  "(9:16) to make your character's home page photo dynamic":
    "(9:16) to make your character's home page photo dynamic.",
  'The uploaded file exceeds the maximum allowed size of 20MB':
    'The uploaded file exceeds the maximum allowed size of 20MB',
  'Upload failed, please try again': 'Upload failed, please try again',
  'Only gif or mp4 can be selected': 'Only GIF or MP4 can be selected',
  'Please upload a GIF, WebP or MP4 file':
    'Please upload a GIF, WebP or MP4 file',
  'AI Upscaling': 'AI Upscaling',
  Upload: 'Upload',
  'Notice: Everything said is generated by AI':
    'Notice: Everything said is generated by AI.',
  'All responses are AI-generated. All characters are depicted as adults aged 18 or above.':
    'All responses are AI-generated. All characters are depicted as adults aged 18 or above.',
  'Your chats and accounts are encrypted':
    'Your chats and accounts are encrypted.',
  Continue: 'Continue',
  'Message Limit Reached': 'Message Limit Reached',
  'Access this feature': 'Access this feature',
  "You've reached your message limit! Upgrade your subscription to keep chatting with the character":
    "You've reached your message limit! Upgrade your subscription to keep chatting with the character.",
  'This feature is exclusive to subscribers Click below to manage your subscription':
    'This feature is exclusive to subscribers. Click below to manage your subscription.',
  'View plans': 'View plans',
  Temperature: 'Temperature',
  'Content Diversity': 'Content Diversity',
  'It will affect the diversity of the character output; the lower the more repetitive':
    'It will affect the diversity of the character output; the lower the more repetitive.',
  'It will affect how characters feel like, the lower the more rigid characters are':
    'It will affect how characters feel like, the lower the more rigid characters are.',
  'Too high temperature': 'Too high temperature',
  '(temperature > 1)': '(temperature > 1)',
  'settings may negatively impact response quality':
    'settings may negatively impact response quality',
  Translation: 'Translation',
  'Rigid and Scripted': 'Rigid and Scripted',
  'Creative and Random': 'Creative and Random',
  Diverse: 'Diverse',
  'Welcome to Tipsy': 'Welcome to Tipsy',
  'By continuing to use our app, you acknowledge that you have read and agreed to our':
    'By continuing to use our app, you acknowledge that you have read and agreed to our',
  and: 'and',
  'You can review these terms at any time in':
    'You can review these terms at any time in',
  'Enjoy your fantasy journey with our AI companions!':
    'Enjoy your fantasy journey with our AI companions!',
  'Accept and Continue': 'Accept and Continue',
  ',': ',',
  '.': '.',
  'My Account - Settings': 'My Account - Settings',
  "I'm Interested in:": "I'm Interested in:",
  'Please select your gender': 'Please select your gender',
  Guys: 'Guys',
  Girls: 'Girls',
  Done: 'Done',
  Version: 'Version',
  'Display limitless content': 'Display limitless content',
  'Do you want to turn on Limitless mode to view 18+ plots and characters. including your own and others on the homepage?':
    'Do you want to turn on Limitless mode to view 18+ plots and characters. including your own and others on the homepage?',
  'Do you want to turn on Limitless mode to view 18+ characters. including your own and others on the homepage?':
    'Do you want to turn on Limitless mode to view 18+ characters. including your own and others on the homepage?',
  Today: 'Today',
  Yesterday: 'Yesterday',
  'Upscaled Results': 'Upscaled Results',
  'Upscale Again': 'Upscale Again',
  'Upload Again': 'Upload Again',
  Choose: 'Choose',
  Translate: 'Translate',
  'Image saved': 'Image saved',
  'Setting parameters too high ( > 1.5) may negatively impact image generation':
    'Setting parameters too high ( > 1.5) may negatively impact image generation',
  'Personalize Your Tipsy Experience': 'Personalize Your Tipsy Experience',
  "Create a unique nickname that represents you. It's how the others will know and remember you":
    "Create a unique nickname that represents you. It's how the others will know and remember you.",
  '1d': '1d',
  'Bug Report': 'Bug Report',
  'Found something broken or not working':
    'Found something broken or not working',
  Suggestion: 'Suggestion',
  'Have ideas for enhancing the app': 'Have ideas for enhancing the app',
  Question: 'Question',
  'Need help or have any inquiries': 'Need help or have any inquiries',
  'Billing & Gems': 'Billing & Gems',
  'Get Help with Top-ups, Payments and Gems':
    'Get Help with Top-ups, Payments and Gems',
  'Maximum Images': 'Maximum Images',
  'Only the first {{maxImages}} images have been added':
    'Only the first {{maxImages}} images have been added',
  'You can only upload up to {{maxImages}} images':
    'You can only upload up to {{maxImages}} images',
  'Let us know how we can help make your experience better':
    'Let us know how we can help make your experience better',
  'Please include screenshots or screen recordings for a quicker resolution':
    'Please include screenshots or screen recordings for a quicker resolution',
  'Please include screenshots/recordings and the Character CID (if applicable) for a faster resolution':
    'Please include screenshots/recordings and the Character CID (if applicable) for a faster resolution',
  'Submission Successful': 'Submission Successful',
  'Submission Failed': 'Submission Failed',
  'Write dialogue normally and enclose any narration within asterisks (*) without spaces immediately following or preceding the asterisks':
    'Write dialogue normally and enclose any narration within asterisks (*) without spaces immediately following or preceding the asterisks.',
  'Inspiration Available': 'Inspiration Available',
  'Free Inspiration': 'Free Inspiration',
  'Change Max Reply Message Length': 'Change Max Reply Message Length',
  'Translation requested': 'Translation requested.',
  'Copied to clipboard': 'Copied, go share it',
  Subscribe: 'Subscribe',
  'Info: This payment method does NOT automatically renew and is only available for a one-time annual payment. Upgrades are possible within the same year, but downgrades are NOT allowed':
    'Info: This payment method does NOT automatically renew and is only available for a one-time annual payment. Upgrades are possible within the same year, but downgrades are NOT allowed.',
  'Drag and drop or click to upload image(optional)':
    'Drag and drop or click to upload image(optional)',
  'add details, eg. facial features, actions, clothing, background (optional)':
    'add details, eg. facial features, actions, clothing, background (optional)',
  'Edit Avatar': 'Edit Avatar',
  'Click to enlarge image': 'Click to enlarge image',
  'Enter to send, Shift+Enter for new line':
    'Enter to send, Shift+Enter for new line',
  'Back to Default Layout': 'Back to Default Layout',
  Copied: 'Copied',
  'Respond as User': 'Respond as User',
  'Public Memories': 'Public Memories',
  'Hide Profile': 'Hide Profile',
  'Get the Tipsy app': 'Get the Tipsy app',
  'Scan QR code to download Tipsy': 'Scan QR code to download Tipsy',
  'Invalid email': 'Invalid email',
  Email: 'Email',
  'An email with the code has been sent to':
    'An email with the code has been sent to',
  'your code': 'your code',
  'Did not get the code': 'Did not get the code?',
  'My Balance': 'My Balance',
  'Bonus Gems': 'Bonus Gems',
  'Search characters': 'Search characters',
  'Message...': 'Message...',
  'After backtracking, the content after the message will be cleared. Please confirm if you want to proceed':
    'After backtracking, the content after the message will be cleared. Please confirm if you want to proceed.',
  'Or continue with': 'or continue with',
  'Edit Image': 'Edit Image',
  'Expiration Date': 'Expiration Date',
  'Custom Voice': 'Custom Voice',
  'Got it': 'Got it',
  "You have two separate accounts for this email created by Sign in with Google and Gmail login. You're currently using one of them.":
    "You have two separate accounts for this email created by Sign in with Google and Gmail login. You're currently using one of them.",
  'No Free Messages': 'No Free Messages',
  'Unlimited Messages': 'Unlimited Messages',
  'Base Model Only': 'Base Model Only',
  'Not now': 'Not now',
  'Permanently delete the chat with Character':
    'Permanently delete the chat with {{character}}',
  'Select All': 'Select All',
  'Quick Select': 'Quick Select',
  'Up to 4K of Memory': 'Up to 4k of Memory',
  'You can add up to 0 base voices': 'You can add up to {{count}} base voices',
  'Get a Taste': 'Get a Taste',
  Standard: 'Standard',
  Premium: 'Premium',
  Deluxe: 'Deluxe',
  'no characters': 'No characters',
  'No characters found': 'No characters found',
  'no memories': 'no memories',
  'no favorites': 'no favorites',
  'no liked': 'no liked',
  'Failed to send message': 'Failed to send message',
  'Backtracking, please wait': 'Backtracking, please wait',
  'Resetting OC, please wait': 'Resetting OC, please wait',
  'Retelling, please wait': 'Retelling, please wait',
  'Sending another message, please wait':
    'Sending another message, please wait',
  'Continue replying message, please wait':
    'Continue replying message, please wait',
  'This memory is private. You can switch your character to “Public” to share it':
    'This memory is private. You can switch your character to “Public” to share it.',
  Enable: 'Enable',
  'Once deleted, it cannot be recovered and if it is public, other users cannot see it anymore. Are you sure?':
    'Once deleted, it cannot be recovered and if it is public, other users cannot see it anymore. Are you sure?',
  Follow: 'Follow',
  Download: 'Download',
  'Delete Chat': 'Delete Chat',
  'No followers': 'No followers',
  Age: 'Age',
  Optional: 'Optional',
  "Here's some basic rules:": "Here's some basic rules:",
  'Enter Tipsy': 'Enter Tipsy',
  "I'm 18 years or older": "I'm 18 years or older",
  'I agree to be bound by our': 'I agree to be bound by our',
  'No hate speech': 'No hate speech',
  'No underage': 'No underage',
  'No incest': 'No incest',
  'No extreme forms of gore/violence': 'No extreme forms of gore/violence',
  'No explicit NSFW pregnant or elderly content':
    'No explicit NSFW pregnant or elderly content',
  'Select Payment Method': 'Select Payment Method',
  "This payment method isn't available in your region.":
    "This payment method isn't available in your region.",
  'Please log in with the same account and upgrade through the same payment method you used for your former plan. Switching payment platforms may cause you to miss out on these savings':
    'Please log in with the same account and upgrade through the same payment method you used for your former plan. Switching payment platforms may cause you to miss out on these savings',
  'Your AI Tavern': 'Your AI Tavern',
  'Message content cannot be empty': 'Message content cannot be empty',
  'Please crop the character avatar': 'Please crop the character avatar',
  'Character received number likes': '{{character}} received {{number}} likes',
  'Please upload an image': 'Please upload an image',
  'You can add up to 0 rounds': 'You can add up to {{count}} rounds',
  'Total dialog style length exceeds limit: current/max':
    'Total dialog style length exceeds limit: {{current}}/{{max}}',
  'Failed to resend message': 'Failed to resend message',
  'Failed to save face image': 'Failed to save face image',
  'No Following': 'No Following',
  'Character background': 'Character background',
  Update: 'Update',
  Rejected: 'Rejected',
  'Describe your character in a few words This will be displayed in the character list':
    'Describe your character in a few words This will be displayed in the character list',
  year: 'year',
  'It is not allowed to edit the plot of the pending state':
    'It is not allowed to edit the plot of the pending state',
  'This feature is exclusive to our app':
    'This feature is exclusive to our app!',
  'To enjoy full functionality, please download our app':
    'To enjoy full functionality, please download our app!',
  'Want to use this function': 'Want to use this function?',
  'You’ve reached your message limit! Upgrade your subscription to keep chatting with the character':
    'You’ve reached your message limit! Upgrade your subscription to keep chatting with the character.',
  'Only Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.':
    'Only Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.',
  'Failed to generate inspiration': 'Failed to generate inspiration',
  'Free Inspiration Uses Left': 'Free inspiration uses left: ',
  '3 Inspirations': '3 Inspirations',
  'Up to 2M of memory': 'Up to 2M of memory',
  'Unlimited Inspirations': 'Unlimited Inspirations',
  'No recent chats': 'No recent chats',
  'Gem Recharge Launch': 'Gem Recharge Launch',
  'Enjoy 20% off this week only!': 'Enjoy 20% off this week only!',
  'Free Gems Giveaway': 'Free Gems Giveaway',
  'Complete tasks to earn 1250+ free gems!':
    'Complete tasks to earn 1250+ free gems!',
  'Creator Rewards Program is Back': 'Creator Rewards Program is Back',
  'Win 500 gems weekly': 'Win 500 gems weekly',
  'announced on Discord!': 'announced on Discord!',
  'Beta phase Creator Rewards are also being distributed this Thanksgiving!':
    'Beta phase Creator Rewards are also being distributed this Thanksgiving!',
  'Learn More & Earn Bonuses!': 'Learn More & Earn Bonuses!',
  'Buy Gems': 'Buy Gems',
  'Time Limit Discount': 'Time Limit Discount',
  'My Balance:': 'My Balance:',
  ThanksGivingTitle: 'PopIconTitleEN',
  'New Feature, Mobile App Only!': 'New Feature, Mobile App Only!',
  'Download the mobile App to enjoy the newest':
    'Download the mobile App to enjoy the newest',
  'Full-screen Browsing Function': 'Full-screen Browsing Function',
  'for a more immersive experience. Try it now!':
    'for a more immersive experience. Try it now!',
  Claim: 'Claim',
  'Bonus Missions': 'Bonus Missions',
  'Increase Your Memory': 'Increase Your Memory',
  'Increase your memory capacity.': 'Increase your memory capacity.',
  'Start a chat first to unlock Increase Your Memory.':
    'Start a chat first to unlock Increase Your Memory.',
  'Download APP': 'Download APP',
  'Download the app and log in to your account.':
    'Download the app and log in to your account.',
  'Download APP and log in to your account to receive a large amount of gems.':
    'Download APP and log in to your account to receive a large amount of gems.',
  "Let's celebrate our Product Hunt launch!":
    "Let's celebrate our Product Hunt launch!",
  'Show Your Love': 'Show Your Love',
  'Love Tipsy Chat? Show your love on Product Hunt and earn gems!':
    'Love Tipsy Chat? Show your love on Product Hunt and earn gems!',
  'Check in failed': 'Check in failed',
  'Checking in...': 'Checking in...',
  'Check-in successful!': 'Check-in successful!',
  'Checked In': 'Checked In',
  'Check In Today': 'Check In Today',
  'Continuous Check-in Task': 'Continuous Check-in Task',
  'Check in for 7 consecutive days to get 490 gems!':
    'Check in for 7 consecutive days to get 490 gems!',
  'New user bonus': 'New user bonus',
  'Check in for 7 consecutive days to earn 490 Gems!':
    'Check in for 7 consecutive days to earn 490 Gems!',
  'Daily Check-in': 'Daily Check-in',
  'Click to check in and get gems, the event will disappear after interruption':
    'Click to check in and get gems, the event will disappear after interruption',
  'Notify me tomorrow': 'Notify me tomorrow',
  Day: 'Day {{day}}',
  Starter: 'Starter',
  'Enter Invitation Code': 'Enter Invitation Code',
  '6 or 8 digits code': '6 or 8 digits code',
  'Enter a code to earn gems. You can only use one code.':
    'Enter a code to earn gems. You can only use one code.',
  Invitation: 'Invitation',
  'Invite New Users': 'Invite New Users',
  'Invite new users to enter your code within 48 hours of signing up. Both you and the invitees will earn gems for each successful invite.':
    'Invite new users to enter your code within 48 hours of signing up. Both you and the invitees will earn gems for each successful invite.',
  'Regenerating...': 'Regenerating...',
  'Your invitation code has been copied to the clipboard.':
    'Your invitation code has been copied to the clipboard.',
  'Invalid invitation code': 'Invalid invitation code',
  'Join Us': 'Join Us',
  'Connect on social media to earn gems！':
    'Connect on social media to earn gems！',
  'Translation in progress, please check back later.':
    'Translation in progress, please check back later.',
  'Translation failed, please try again.':
    'Translation failed, please try again.',
  'On Trial': 'On Trial',
  'Unlimited messages in trial…': 'Unlimited messages in trial…',
  'Enjoy Free Trial!': 'Enjoy Free Trial!',
  'Congratulations! You’ve unlocked a 3-day free trial of Subscription features. Enjoy an upgraded experience—start exploring now!':
    'Congratulations! You’ve unlocked a <b style="font-weight: 900;">3-day free trial</b> of Subscription features. Enjoy an upgraded experience—start exploring now!',
  'Experience now': 'Experience now',
  'Congratulations! Your relationship level has increased to Lv.{{newLevel}}.':
    'Congratulations! Your relationship level has increased to Lv.{{newLevel}}.',
  'Relationship upgraded to {{levelName}}':
    'Relationship upgraded to {{levelName}}',
  'Claim Now': 'Claim Now',
  Go: 'Go',
  'Random Reward Unlocked <highlight>+{{amount}}Gems</highlight> Probability only <highlight>{{probability}}%</highlight> What a lucky one':
    'Random Reward Unlocked <highlight>+{{amount}}Gems</highlight> Probability only <highlight>{{probability}}%</highlight> What a lucky one',
  'Trial Ends Today!': 'Trial Ends Today!',
  'This is your final day enjoying the free trial of our Subscription features! You’ll lose access to Unlimited Messages, Endless Inspiration, and Adjustable Response Length.':
    'This is your <b style="font-weight: 900;">final day</b> enjoying the <b style="font-weight: 900;">free trial</b> of our Subscription features! You’ll lose access to Unlimited Messages, Endless Inspiration, and Adjustable Response Length.',
  '+100 Gems (New User Only)': '+100 Gems (New User Only)',
  '+400 Gems (New User Only)': '+400 Gems (New User Only)',
  '+500 Gems (New User Only)': '+500 Gems (New User Only)',
  '+1200 Gems (New User Only)': '+1200 Gems (New User Only)',
  '+2500 Gems (New User Only)': '+2500 Gems (New User Only)',
  '+7500 Gems (New User Only)': '+7500 Gems (New User Only)',
  '+16000 Gems (New User Only)': '+16000 Gems (New User Only)',
  '+100 Gems': '+100 Gems',
  '+400 Gems': '+400 Gems',
  '+500 Gems': '+500 Gems',
  '+1200 Gems': '+1200 Gems',
  '+2500 Gems': '+2500 Gems',
  '+7500 Gems': '+7500 Gems',
  '+16000 Gems': '+16000 Gems',
  '+800 Gems': '+800 Gems',
  '+4000 Gems': '+4000 Gems',
  '+15000 Gems': '+15000 Gems',
  '+6000 Gems': '+6000 Gems',
  '+25000 Gems': '+25000 Gems',
  '+50000 Gems': '+50000 Gems',
  'New User Only': 'New User Only',
  left: 'left',
  '(3 days left)': '(3 days left)',
  '(2 days left)': '(2 days left)',
  '(1 days left)': '(1 day left)',
  'Credit Card': 'Credit Card',
  'Say Something...': 'Say Something...',
  'Continue Conversation...': 'Continue Conversation...',
  'Enter invitation code to earn gems (Optional)':
    'Enter invitation code to earn gems (Optional)',
  'Recent Search': 'Recent Search',
  'Popular Search': 'Popular Search',
  Clear: 'Clear',
  'Clear All Search Record': 'Clear All Search Record',
  'Are you sure to clear all search records?':
    'Are you sure to clear all search records?',
  Creators: 'Creators',
  'Create Now': 'Create Now',
  '+800 Gems (Limited Time Offer)': '+800 Gems (Limited Time Offer)',
  '+4000 Gems (Limited Time Offer)': '+4000 Gems (Limited Time Offer)',
  '+15000 Gems (Limited Time Offer)': '+15000 Gems (Limited Time Offer)',
  'Xmas & Year-End Discount!': 'Xmas & Year-End Discount!',
  'Merry Christmas & Happy New Year!': 'Merry Christmas & Happy New Year!',
  'Let’s celebrate the joy and warmth of the holiday season together!':
    'Let’s celebrate the joy and warmth of the holiday season together!',
  'Annual Subscription Discount': 'Annual Subscription Discount',
  'Get up to 5000 Gems with your yearly subscription – hurry, don’t miss out!':
    'Get up to 15000 Gems with your yearly subscription – hurry, don’t miss out!',
  'Exclusive Gift': 'Exclusive Gift',
  'Santa’s dropped a Christmas Hat on your profile – wear it before it’s gone!':
    'Santa’s dropped a Christmas Hat on your profile – wear it before it’s gone!',
  'Holiday Deal!': 'Holiday Deal!',
  'Celebrate the Holidays with 5000 Gems! Get a yearly subscription and enjoy this festive giveaway!':
    'Celebrate the Holidays with 15000 Gems! Get a yearly subscription and enjoy this festive giveaway!',
  'Exclusive savings for first-timers!': 'Exclusive savings for first-timers!',
  'Gems Giveaway:': 'Gems Giveaway:',
  View: 'View',
  'Other Payments': 'Other Payments',
  'Monthly Subscription': 'Monthly Subscription',
  'Annual Subscription': 'Annual Subscription',
  'Other Payment Methods': 'Other Payment Methods',
  'Security Notifications': 'Security Notifications',
  'End-to-end encryption keeps your personal chats between you and the characters you choose. Not even Tipsy can see or read them, unless you choose to share them. This includes your:':
    'End-to-end encryption keeps your personal chats between you and the characters you choose. Not even Tipsy can see or read them, unless you choose to share them. This includes your:',
  'Text and voice messages': 'Text and voice messages',
  'Viewing history': 'Viewing history',
  'Private memories and characters': 'Private memories and characters',
  'Image generation record': 'Image generation record',
  'Status updates': 'Status updates',
  'Delete This Character?': 'Delete This Character?',
  'This action is permanent and cannot be reversed.':
    'This action is permanent and cannot be reversed.',
  'My Plan': 'My Plan',
  'Subscription FAQ': 'Subscription FAQ',
  "Beginner's Guide": "Beginner's Guide",
  Subscription: 'Subscription',
  Unsubscribe: 'Unsubscribe',
  'Upgrade My Plan': 'Upgrade My Plan',
  "Are you sure you want to unsubscribe? Your subscription will not be renewed, but you will retain access to this month's services.":
    "Are you sure you want to unsubscribe? Your subscription will not be renewed, but you will retain access to this month's services.",
  'How to cancel your subscription?': 'How to cancel your subscription?',
  '1. Open the "Settings" app on your iPhone or iPad.':
    '1. Open the "Settings" app on your iPhone or iPad.',
  '2. Tap your Apple ID at the top.': '2. Tap your Apple ID at the top.',
  '3. Select "Subscriptions".': '3. Select "Subscriptions".',
  '4. Find and tap the subscription you want to cancel.':
    '4. Find and tap the subscription you want to cancel.',
  '5. Tap "Cancel Subscription" and confirm.':
    '5. Tap "Cancel Subscription" and confirm.',
  'Restore Subscription': 'Restore Subscription',
  'Successfully Restored': 'Successfully Restored',
  'Payment Successful': 'Payment Successful',
  'Your gems have been credited to your account.':
    'Your gems have been credited to your account.',
  'Insufficient balance / Network timeout':
    'Insufficient balance / Network timeout',
  'Payment cancelled': 'Payment cancelled',
  'Select Payment Type': 'Select Payment Type',
  'Your payment is encrypted and secure.':
    'Your payment is encrypted and secure.',
  'Redirect to Tipsy': 'Redirect to Tipsy',
  'View and Restore': 'View and Restore',
  "Please click 'Restore Subscription' first, then select this plan to change your subscription.":
    "Please click 'Restore Subscription' first, then select this plan to change your subscription.",
  'Subscription updated successfully. New benefits will activate after this cycle ends, with payment adjusted to the new level.':
    'Subscription updated successfully. New benefits will activate after this cycle ends, with payment adjusted to the new level.',
  'Confirm this change? Your new subscription takes effect now; the current membership will be canceled without refunds.':
    'Confirm this change? Your new subscription takes effect now; the current membership will be canceled without refunds.',
  'Messages consume gems based on model: Blue gem first, then Red gem.':
    'Messages consume gems based on model: Blue gem first, then Red gem.',
  'Unlimited Messaging on Specific Models':
    'Unlimited Messaging on Specific Models',
  'Free 40,000 Blue Gems/month': 'Free 40,000 Blue Gems/month',
  'Free 20,000 Blue Gems/month': 'Free 20,000 Blue Gems/month',
  'Free 6,000 Blue Gems/month': 'Free 6,000 Blue Gems/month',
  'Free 2,000 Blue Gems/month': 'Free 2,000 Blue Gems/month',
  'Free 1,000 Blue Gems/month': 'Free 1,000 Blue Gems/month',
  'Free 3,600 Blue Gems/month': 'Free 3,600 Blue Gems/month',
  'Free 12,000 Blue Gems/month': 'Free 12,000 Blue Gems/month',
  'Free 25,000 Blue Gems/month': 'Free 25,000 Blue Gems/month',
  'Free 1,200 Blue Gems/month': 'Free 1,200 Blue Gems/month',
  'Free 4,000 Blue Gems/month': 'Free 4,000 Blue Gems/month',
  'Free 15,000 Blue Gems/month': 'Free 15,000 Blue Gems/month',
  'Free 30,000 Blue Gems/month': 'Free 30,000 Blue Gems/month',
  'No Free Gems': 'No Free Gems',
  'We offer two types of gems: Red Gems, which lasts forever and can be earned or purchased, and Blue Gems, refreshed monthly with a subscription. Both available for all models.':
    'We offer two types of gems: Red Gems, which lasts forever and can be earned or purchased, and Blue Gems, refreshed monthly with a subscription. Both available for all models.',
  'gem/message': 'gem/message',
  'Version Update': 'Version Update',
  'More Payment Methods': 'More Payment Methods',
  'We’ve added Paypal monthly payment option.':
    'We’ve added Paypal monthly payment option.',
  'New Model & Gems Change': 'New Model & Gems Change',
  'We will introduce some of the': 'We will introduce some of the',
  'best models worldwide': 'best models worldwide',
  'and make all models available to everyone with different gem cost. Chats will now primarily consume monthly-refreshing blue gems(formerly free messages), followed by permanent red gems.':
    'and make all models available to everyone with different gem cost. Chats will now primarily consume monthly-refreshing blue gems(formerly free messages), followed by permanent red gems.',
  'For ALL IN users, you can still enjoy':
    'For ALL IN users, you can still enjoy',
  'unlimited chats with existing models for free':
    'unlimited chats with existing models for free',
  'For new models, we are giving you an additional 20,000 blue gems per month to enjoy them.':
    'For new models, we are giving you an additional 20,000 blue gems per month to enjoy them.',
  'Your subscription has been restored. Charges will apply after current benefits expire this month, and your benefits will be updated.':
    'Your subscription has been restored. Charges will apply after current benefits expire this month, and your benefits will be updated.',
  'Your subscription has been modified. After current benefits expire this month, charges will reflect the new price, and your benefits will be updated.':
    'Your subscription has been modified. After current benefits expire this month, charges will reflect the new price, and your benefits will be updated.',
  'Report Message': 'Report Message',
  "Inconsistent Reply (The response wasn't in line with the previous conversation.)":
    "Inconsistent Reply (The response wasn't in line with the previous conversation.)",
  'Incomplete Response': 'Incomplete Response',
  "Stuck in 'Pending Approval'": "Stuck in 'Pending Approval'",
  'Incorrect Rating': 'Incorrect Rating',
  'Appeal Content Removal': 'Appeal Content Removal',
  Other: 'Other',
  'Involving Minors': 'Involving Minors',
  'Sensitive Topics': 'Sensitive Topics',
  'Disturbing Content': 'Disturbing Content',
  'Copyright Infringement': 'Copyright Infringement',
  'Sexual Content': 'Sexual Content',
  'Child Endangerment': 'Child Endangerment',
  'Sensitve Content': 'Sensitive Content',
  'Hate Speech': 'Hate Speech',
  'Violence, Self-Injury and Terrorism': 'Violence, Self-Injury and Terrorism',
  'Insult and Abuse': 'Insult and Abuse',
  'Dangerous Products': 'Dangerous Products',
  'Spam and Advertisement': 'Spam and Advertisement',
  Report: 'Report',
  'Report Character': 'Report this Character',
  'Priority Image Generation': 'Priority Image Generation',
  'Payment Alert': 'Payment Alert',
  'Ensure you have enough cryptocurrency to complete the transaction.':
    'Ensure you have enough cryptocurrency to complete the transaction.',
  "Please allow 5-15 minutes for processing. If you haven't received your benefits after this time, try refreshing the page and contact us if needed.":
    "Please allow 5-15 minutes for processing. If you haven't received your benefits after this time, try refreshing the page and contact us if needed.",
  'Higher memory means higher cost - 32K requires 4x gems.':
    'Higher memory means higher cost - 32K requires 4x gems.',
  'Higher memory means higher cost - 16K requires 2x gems.':
    'Higher memory means higher cost - 16K requires 2x gems.',
  'Higher memory means higher cost - 4k requires 1x gems.':
    'Higher memory means higher cost - 4k requires 1x gems.',
  'Higher memory means higher cost - 8k requires 1x gems.':
    'Higher memory means higher cost - 8k requires 1x gems.',
  'Higher memory means higher cost - 64K requires 7x gems.':
    'Higher memory means higher cost - 64K requires 7x gems.',
  'Higher memory means higher cost - 128K requires 12x gems.':
    'Higher memory means higher cost - 128K requires 12x gems.',
  'Higher memory means higher cost - 200K requires 16x gems.':
    'Higher memory means higher cost - 200K requires 16x gems.',
  'Only Standard/Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.':
    'Only Standard/Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.',
  'Only Deluxe subscription users can use. You can click the button to upgrade your subscription.':
    'Only Deluxe subscription users can use. You can click the button to upgrade your subscription.',
  'Only I’m All In subscription users can use You can click the button to upgrade your subscription':
    'Only I’m All In subscription users can use You can click the button to upgrade your subscription',
  'Only Get a Taste/Standard/Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.':
    'Only Get a Taste/Standard/Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.',
  'Memory 8k': 'Memory 8k',
  'Memory 16k': 'Memory 16k',
  'Memory 32k': 'Memory 32k',
  'Memory 4k': 'Memory 4k',
  'Memory 64k': 'Memory 64k',
  'Memory 128k': 'Memory 128k',
  'Memory 200k': 'Memory 200k',
  'Free for Get a Taste': 'Free for Get a Taste',
  'Free for Premium': 'Free for Premium',
  'Free for Deluxe': 'Free for Deluxe',
  'Free for Standard': 'Free for Standard',
  'Free for On Trial': 'Free for On Trial',
  Plan: 'Plan',
  'A Warm Thank You with 400 free gems!':
    'A Warm Thank You with 400 free gems!',
  'Daily Check-in Adjustment': 'Daily Check-in Adjustment',
  'Due to the increasing number of free users, we’ve made the difficult decision to adjust the daily check-in rewards to 10 gems per day in order to better support our paying customers.':
    'Due to the increasing number of free users, we’ve made the difficult decision to adjust the daily check-in rewards to 10 gems per day in order to better support our paying customers.',
  'Daily Check-In Rewards Adjustments': 'Daily Check-In Rewards Adjustments',
  'Due to the increasing number of free users, we’ve been facing higher GPU costs, which are unsustainable for us at the current rate. As a result, we’ve made the difficult decision to adjust the daily check-in rewards to 10 gems per day.':
    'Due to the increasing number of free users, we’ve been facing higher GPU costs, which are unsustainable for us at the current rate. As a result, we’ve made the difficult decision to adjust the daily check-in rewards to 10 gems per day.',
  'While we understand this may be disappointing, please know this change is necessary to continue providing a stable service. Thanks for your understanding and we’re committed to making ongoing improvements and ensuring a great experience for all.':
    'While we understand this may be disappointing, please know this change is necessary to continue providing a stable service. Thanks for your understanding and we’re committed to making ongoing improvements and ensuring a great experience for all.',
  '400 gems give away to True Supporters':
    '400 gems give away to True Supporters',
  'As a heartfelt thank-you for your continuous support, we are giving away 400 bonus gems to our True Supporters! We truly appreciate having you with us on this journey.':
    'As a heartfelt thank-you for your continuous support, we are giving away 400 bonus gems to our True Supporters! We truly appreciate having you with us on this journey.',
  'A Warm Thank You with 1000 free gems!':
    'A Warm Thank You with 1000 free gems!',
  '1000 gems give away to All-In Users': '1000 gems give away to All-In Users',
  'As a heartfelt thank-you for your continuous support, we are giving away 1000 gems to our All-In Users! Your support means the world to us!':
    'As a heartfelt thank-you for your continuous support, we are giving away 1000 gems to our All-In Users! Your support means the world to us!',
  "You Don't Have Any Notifications": "You Don't Have Any Notifications",
  Notification: 'Notification',
  System: 'System',
  Personal: 'Personal',
  Engagement: 'Engagement',
  'liked your work!': 'liked your work!',
  'added your work to their favorites!': 'added your work to their favorites!',
  'replied to your comment': 'replied to your comment',
  'liked your comment': 'liked your comment',
  'commented on your character': 'commented on your character',
  'commented on your world': 'commented on your world',
  'No comments yet, be the first!': 'No comments yet, be the first!',
  'Out of gems! Please acquire more to continue.':
    'Out of gems! Please acquire more to continue.',
  'Upgrade Plan': 'Upgrade Plan',
  'Priority Image Generation for Character Creation':
    'Priority Image Generation for Character Creation',
  "Your benefits will be updated immediately, and your payment will be charged right away. You won't lose any remaining value on your current plan.":
    "Your benefits will be updated immediately, and your payment will be charged right away. You won't lose any remaining value on your current plan.",
  'Credit Card Payment Update': 'Credit Card Payment Update',
  "We've upgraded our payment system for a smoother experience! Your plan has expired and won't auto-renew. Simply resubscribe to keep enjoying your benefits—future renewals will be automatic!":
    "We've upgraded our payment system for a smoother experience! Your plan has expired and won't auto-renew. Simply resubscribe to keep enjoying your benefits—future renewals will be automatic!",
  'Download and pay in the': 'Download and pay in the {{platform}}',
  "We're sorry to see you go": "We're sorry to see you go",
  "We'd really appreciate your feedback. Let us know why you're canceling—your input helps us improve and better serve you in the future.":
    "We'd really appreciate your feedback. Let us know why you're canceling—your input helps us improve and better serve you in the future.",
  "The features didn't meet my needs": "The features didn't meet my needs",
  'Unpleasant chat experience': 'Unpleasant chat experience',
  "I don't use it often enough": "I don't use it often enough",
  "It's too expensive": "It's too expensive",
  'I found a better alternative': 'I found a better alternative',
  'I experienced technical issues': 'I experienced technical issues',
  'Other (please specify below)': 'Other (please specify below)',
  "Have any thoughts or suggestions you'd like to share?":
    "Have any thoughts or suggestions you'd like to share?",
  'Submit & Cancel': 'Submit & Cancel',
  'First Recharge Bonus': 'First Recharge Bonus',
  'Huge bonus, one-time only!': 'Huge bonus, one-time only!',
  'One-time only': 'One-time only',
  'Create a Private Character': 'Create a Private Character',
  'Create your first private character and earn gems.':
    'Create your first private character and earn gems.',
  'Create a Character': 'Create a Character',
  'Create your first character and earn gems.':
    'Create your first character and earn gems.',
  'Create your first character': 'Create your first character',
  'You can claim gems in Gem Missions.': 'You can claim gems in Gem Missions.',
  'Upgrade to the Annual Subscription by paying the difference and enjoying big savings.':
    'Upgrade to the Annual Subscription by paying the difference and enjoying big savings.',
  'Enjoy a 2-day free trial to unlock AI Reply Length control.':
    'Enjoy a 2-day free trial to unlock AI Reply Length control.',
  'Get up to 50% off annual plans. Limited time only!':
    'Get up to 50% off annual plans. Limited time only!',
  'Highly Recommend Model——': 'Highly Recommend Model——',
  'Easter Deals Are Back!': 'Easter Deals Are Back!',
  'Try Premium Feature for Free!': 'Try Premium Feature for Free!',
  'Meet Claude 3.7, our smartest model yet. Paired with 500-length replies, it’s the ultimate power combo.':
    'Meet Claude 3.7, our smartest model yet. Paired with 500-length replies, it’s the ultimate power combo.',
  'Save up to': 'Save up to',
  'Up to 30,000': 'Up to 30,000',
  'New Feature Access': 'New Feature Access',
  'Image generation failed. You were not charged.':
    'Image generation failed. You were not charged.',
  'Video generation failed. You were not charged.':
    'Video generation failed. You were not charged.',
  'NSFW content cannot be generated. You were not charged.':
    'NSFW content cannot be generated. You were not charged.',
  'Image failed moderation review. You were not charged.':
    'Image failed moderation review. You were not charged.',
  'Moderation Failed': 'Moderation Failed',
  'Cannot select image that failed moderation review':
    'Cannot select image that failed moderation review',
  'Unlock New Feature': 'Unlock New Feature',
  'Character inconsistency': 'Character inconsistency',
  'Unrealistic content': 'Unrealistic content',
  'Style mismatch': 'Style mismatch',
  "Doesn't match the plot": "Doesn't match the plot",
  'Stiff expression': 'Stiff expression',
  'Awkward pose': 'Awkward pose',
  'Blurry image': 'Blurry image',
  'Lacks detail': 'Lacks detail',
  'Too slow': 'Too slow',
  Like: 'Like',
  'Report Image/Video': 'Report Image/Video',
  Generated: 'Generated',
  Default: 'Default',
  'Add Role Card': 'Add Role Card',
  'Edit Role Card': 'Edit Role Card',
  'No Role Cards Yet': 'No Role Cards Yet',
  'Editing your role card will not affect existing conversations automatically. You can choose whether to load the new profile to keep the previous one when you reopen your conversations.':
    'Editing your role card will not affect existing conversations automatically. You can choose whether to load the new profile to keep the previous one when you reopen your conversations.',
  'Characters will remember your role information to create better conversations with you.':
    'Characters will remember your role information to create better conversations with you.',
  'What would you like the characters to call you?':
    'What would you like the characters to call you?',
  Dislike: 'Dislike',
  'Must be at least 18 years old.': 'Must be at least 18 years old.',
  'Share what you like.': 'Share what you like.',
  'Share what you dislike.': 'Share what you dislike.',
  'Tell us more about yourself.': 'Tell us more about yourself.',
  'Set as the default for new chats.': 'Set as the default for new chats.',
  'Clear Default': 'Clear Default',
  'Create Avatar': 'Create Avatar',
  'Up to 3 Role Cards': 'Up to 3 Role Cards',
  'Up to 10 Role Cards': 'Up to 10 Role Cards',
  'Up to 20 Role Cards': 'Up to 20 Role Cards',
  'Up to 100 Role Cards': 'Up to 100 Role Cards',
  'Unlimited Role Cards': 'Unlimited Role Cards',
  'Creation Limit Reached': 'Creation Limit Reached',
  'You’ve reached the limit for role cards. Upgrade your plan to create more.':
    'You’ve reached the limit for role cards. Upgrade your plan to create more.',
  'Update Your Role Card': 'Update Your Role Card',
  "You've made some changes to your role card in role card center. Would you like to update it here too?":
    "You've made some changes to your role card in role card center. Would you like to update it here too?",
  Ignore: 'Ignore',
  'Change Role Card': 'Change Role Card',
  'There are some differences between the current role card copy and the original one in the role cards center. Would you like to synchronize the modifications to the center before changing it?':
    'There are some differences between the current role card copy and the original one in the role cards center. Would you like to synchronize the modifications to the center before changing it?',
  'Change Directly': 'Change Directly',
  'Sync and Change': 'Sync and Change',
  'Remove this role card?': 'Remove this role card?',
  'There are some differences between the current role card copy and the original one in the role cards center. Would you like to synchronize the modifications to the center before removing it?':
    'There are some differences between the current role card copy and the original one in the role cards center. Would you like to synchronize the modifications to the center before removing it?',
  'Remove Directly': 'Remove Directly',
  'Sync and Remove': 'Sync and Remove',
  'Are you sure you would like to remove the role card from this conversation? It will cause personal information in the chat history to be updated.':
    'Are you sure you would like to remove the role card from this conversation? It will cause personal information in the chat history to be updated.',
  Remove: 'Remove',
  'In Use': 'In Use',
  'Changing the role card mid-chat may affect story coherence. To avoid this, consider resetting the chat before switching cards.':
    'Changing the role card mid-chat may affect story coherence. To avoid this, consider resetting the chat before switching cards.',
  'Update the original role card in the role card center. (You can choose whether to apply it to other conversations later.)':
    'Update the original role card in the role card center. (You can choose whether to apply it to other conversations later.)',
  'Turn On': 'Turn On',
  'Upload Avatar': 'Upload Avatar',
  'The uploaded image exceeds the maximum allowed size of 20MB.':
    'The uploaded image exceeds the maximum allowed size of 20MB.',
  'Your name in the story.': 'Your name in the story.',
  Change: 'Change',
  'Auto Image': 'Auto Image',
  'Auto Video': 'Auto Video',
  Off: 'Off',
  'Try our new visual features': 'Try our new visual features',
  'Swipe right to switch modes.': 'Swipe right to switch modes.',
  'Tap to generate an image': 'Tap to generate an image',
  'Auto-create images and videos as you chat':
    'Auto-create images and videos as you chat',
  'Tap to generate a video': 'Tap to generate a video',
  'Role Card': 'Role Card',
  Pinned: 'Pinned',
  'View chat history': 'View chat history',
  'Download success.': 'Download success.',
  'Download failed.': 'Download failed.',
  'Download Without Watermark': 'Download Without Watermark',
  'No watermark (Members Only)': 'No watermark (Members Only)',
  'Downloading...': 'Downloading...',
  'Do you want to delete this moment?': 'Do you want to delete this moment?',
  'Delete success.': 'Delete success.',
  'Delete failed.': 'Delete failed.',
  'Deleting...': 'Deleting...',
  'Invite new users to enter your code within 48 hours of signing up! You’ll both earn gems for each successful invite. Misuse may result in an account ban.':
    'Invite new users to enter your code within 48 hours of signing up! You’ll both earn gems for each successful invite. Misuse may result in an account ban.',
  'Image regenerated successfully.': 'Image regenerated successfully.',
  'Video regenerated successfully.': 'Video regenerated successfully.',
  'Image generation failed.': 'Image generation failed.',
  'Video generation failed.': 'Video generation failed.',
  'Image regeneration failed. You were not charged.':
    'Image regeneration failed. You were not charged.',
  'Video regeneration failed. You were not charged.':
    'Video regeneration failed. You were not charged.',
  'My role label (e.g. Lover, Enemy, Guardian)':
    'My role label (e.g. Lover, Enemy, Guardian)',
  None: 'None',
  Label: 'Label',
  'Are you sure you would like to delete this role card? Deleting it will not affect existing conversations.':
    'Are you sure you would like to delete this role card? Deleting it will not affect existing conversations.',
  'Turn off Auto-Create Images': 'Turn off Auto-Create Images',
  'When Auto is enabled, an image will be automatically created with each message. Each image costs 20 gems. Are you sure you want to turn it off?':
    'When Auto is enabled, an image will be automatically created with each message. Each image costs 20 gems. Are you sure you want to turn it off?',
  'When Auto is enabled, an image will be automatically created with each message. Each image costs {{gems}} gems. Are you sure you want to turn it off?':
    'When Auto is enabled, an image will be automatically created with each message. Each image costs {{gems}} gems. Are you sure you want to turn it off?',
  'Turn off': 'Turn off',
  Deal: 'Deal',
  Event: 'Event',
  Bonus: 'Bonus',
  Activity: 'Activity',
  'Swipe right to view the full-screen image. Tap the image for more options.':
    'Swipe right to view the full-screen image. Tap the image for more options.',
  'Swipe right to view the full-screen video. Tap the video for more options.':
    'Swipe right to view the full-screen video. Tap the video for more options.',
  'Auto-Create Images': 'Auto-Create Images',
  'Auto-Create Videos': 'Auto-Create Videos',
  'Create a Reel': 'Create a Reel',
  'When Auto is enabled, an image will be automatically created with each message. You can turn off the Auto at any time. Each image costs 20 gems.':
    'When Auto is enabled, an image will be automatically created with each message. You can turn off the Auto at any time. Each image costs 20 gems.',
  'When Auto is enabled, an image will be automatically created with each message. You can turn off the Auto at any time. Each image costs {{gems}} gems.':
    'When Auto is enabled, an image will be automatically created with each message. You can turn off the Auto at any time. Each image costs {{gems}} gems.',
  'When Auto is enabled, a video will be automatically created with each message. You can turn off the Auto at any time. Each video costs 100 gems.':
    'When Auto is enabled, a video will be automatically created with each message. You can turn off the Auto at any time. Each video costs 100 gems.',
  'When Auto is enabled, a video will be automatically created with each message. You can turn off the Auto at any time. Each video costs {{gems}} gems.':
    'When Auto is enabled, a video will be automatically created with each message. You can turn off the Auto at any time. Each video costs {{gems}} gems.',
  'A world is waiting. A story is ready.':
    'A world is waiting. A story is ready.',
  'Step into an interactive roleplay where your decisions shape the experience.':
    'Step into an interactive roleplay where your decisions shape the experience.',
  'Who will you meet today?': 'Who will you meet today?',
  Him: 'Him',
  Her: 'Her',
  Both: 'Both',
  'Play Now': 'Play Now',
  Share: 'Share',
  Video: 'Video',
  'This share does not include your chats.':
    'This share does not include your chats.',
  'Generate and Share Images': 'Generate and Share Images',
  'Create images using real-time generation and share them on social media. No duplicates - earn up to 15 gems daily.':
    'Create images using real-time generation and share them on social media. No duplicates - earn up to 15 gems daily.',
  'Generate and Share Videos': 'Generate and Share Videos',
  'Create videos using real-time generation and share them on social media. No duplicates - earn up to 60 gems daily.':
    'Create videos using real-time generation and share them on social media. No duplicates - earn up to 60 gems daily.',
  Daily: 'Daily',
  'Shared successfully, +{{amount}} gems':
    'Shared successfully, +{{amount}} gems',
  'Create Character': 'Create',
  'Create Story': 'Create Story',
  'Up to 2MB': 'Up to 2MB',
  'Uploading…': 'Uploading…',
  'File size exceeds 2MB.': 'File size exceeds 2MB.',
  'World Book': 'World Book',
  'Detected {{count}} entries': 'Detected {{count}} entries',
  'Only JSON files are supported.': 'Only JSON files are supported.',
  'Only TXT files are supported.': 'Only TXT files are supported.',
  'Only TXT or JSON files are supported.':
    'Only TXT or JSON files are supported.',
  'background too long, limit 1000K tokens':
    'background too long, limit 1000K tokens',
  'Min memory limit {{min}}K': 'Min memory limit {{min}}K',
  'Multi-character': 'Multi-character',
  Title: 'Title',
  'A unique title for your story.': 'A unique title for your story.',
  'A brief description of your story. This will be displayed on the story card and home page.':
    'A brief description of your story. This will be displayed on the story card and home page.',
  Opening: 'Opening',
  'Opening is required': 'Opening is required',
  'More Settings': 'More Settings',
  'Character id not found': 'Character ID not found',
  Background: 'Background',
  'Describe anything you want about your story, such as the setting, world building, characters, plot elements, or any other details. You can also upload a novel or script directly.':
    'Describe anything you want about your story, such as the setting, world building, characters, plot elements, or any other details. You can also upload a novel or script directly.',
  'Character List': 'Character List',
  User: 'User',
  Character: 'Character',
  'Story Title': 'Story Title',
  'Story Summary': 'Story Summary',
  Prologue: 'Prologue',
  'User Information': 'User Information',
  'User Avatar': 'User Avatar',
  'User Name': 'User Name',
  'User Settings': 'User Settings',
  'Give your story a name that captures its spirit.':
    'Give your story a name that captures its spirit.',
  'Describe your story in a sentence or two —— this will appear in the story list.':
    'Describe your story in a sentence or two —— this will appear in the story list.',
  'Set the scene or let a character introduce themselves to draw readers in.':
    'Set the scene or let a character introduce themselves to draw readers in.',
  'Cover Image': 'Cover Image',
  'Plot & Character Details': 'Plot & Character Details',
  "Add keywords to describe your story's themes, genres, or characters.":
    "Add keywords to describe your story's themes, genres, or characters.",
  'Share more about the world, plot, or character personalities to make your story feel vivid and immersive.':
    'Share more about the world, plot, or character personalities to make your story feel vivid and immersive.',
  Stories: 'Stories',
  'This story has been published and cannot be deleted.':
    'This story has been published and cannot be deleted.',
  'Start Creating': 'Start Creating',
  Story: 'Story',
  'No Story': 'No Story',
  'Enter the name of the character the user will play in the story':
    'Enter the name of the character the user will play in the story',
  'The user’s identity, personality, and background will be known to other characters as part of the story.':
    'The user’s identity, personality, and background will be known to other characters as part of the story.',
  'Story Tagline': 'Story Tagline',
  'Story Background': 'Story Background',
  'Story Detail': 'Story Detail',
  'Report Story': 'Report Story',
  'Sound Library': 'Sound Library',
  Auto: 'Auto',
  'Voice Autoplay': 'Voice Autoplay',
  'Voice will play automatically, with gems deducted according to the message length. You can turn this feature off anytime.':
    'Voice will play automatically, with gems deducted according to the message length. You can turn this feature off anytime.',
  'Play Voice': 'Play Voice',
  'Playing voice costs gems based on the length of the message. To play automatically, enable voice autoplay at the top of the chat.':
    'Playing voice costs gems based on the length of the message. To play automatically, enable voice autoplay at the top of the chat.',
  'Not Now': 'Not Now',
  Play: 'Play',
  'Add details such as facial features, actions, clothing, and background':
    'Add details such as facial features, actions, clothing, and background',
  'Image Description': 'Image Description',
  'Generate Quantity': 'Generate Quantity',
  'Reference Image': 'Reference Image',
  'Generate Avatar based on uploaded facial reference image.':
    'Generate Avatar based on uploaded facial reference image.',
  'Summer Sale is here!': 'Summer Sale is here!',
  'July 6 – July 20 (UTC)': 'July 6 – July 20 (UTC)',
  'There are moments that only belong to summer.':
    'There are moments that only belong to summer.',
  'Unlock up to 50,000 bonus gems with a yearly subscription - and let the story unfold.':
    'Unlock up to 50,000 bonus gems with a yearly subscription - and let the story unfold.',
  '+1200 Gems (Limited Time Offer)': '+1200 Gems (Limited Time Offer)',
  '+6000 Gems (Limited Time Offer)': '+6000 Gems (Limited Time Offer)',
  '+25000 Gems (Limited Time Offer)': '+25000 Gems (Limited Time Offer)',
  '+50000 Gems (Limited Time Offer)': '+50000 Gems (Limited Time Offer)',
  'Summer Sale!': 'Summer Sale!',
  'Summer Sale is Here!': 'Summer Sale is Here!',
  "Hello Summer! Let's make it unforgettable.":
    "Hello Summer! Let's make it unforgettable.",
  'Celebrate the warmth of the season with exclusive bonuses!':
    'Celebrate the warmth of the season with exclusive bonuses!',
  'Recharge Bonus:': 'Recharge Bonus:',
  'Get up to 25% extra gems when you top up—only for a limited time!':
    'Get up to 25% extra gems when you top up—only for a limited time!',
  '25% Bonus': '25% Bonus',
  'Earn Bonuses »': 'Earn Bonuses »',
  'Up To 50,000': 'Up To 50,000',
  'Upgrade »': 'Upgrade »',
  'Annual Subscription Special:': 'Annual Subscription Special:',
  'Subscribe yearly and earn up to 50,000 bonus gems to light up your summer!':
    'Subscribe yearly and earn up to 50,000 bonus gems to light up your summer!',
  'Enter a text prompt or drop reference images.':
    'Enter a text prompt or drop reference images.',
  'Pick a role card below.': 'Pick a role card below.',
  'Welcome to Story Mode': 'Welcome to Story Mode',
  'Stories use a different default model than characters. Each multi-role story also has a minimum memory length that cannot be set below its required value.':
    'Stories use a different default model than characters. Each multi-role story also has a minimum memory length that cannot be set below its required value.',
  'Start Adventure': 'Start Adventure',
  'Must be less than 127 years old.': 'Must be less than 127 years old.',
  'Create Multi-character': 'Create Multi-character',
  'Multi-character Title': 'Multi-character Title',
  'No Multi-character': 'No Multi-character',
  'Multi-character Tagline': 'Multi-character Tagline',
  'Multi-character Background': 'Multi-character Background',
  'Report Multi-character': 'Report Multi-character',
  'Video Sound On': 'Video Sound On',
  'Report this Character': 'Report this Character',
  'Inspiration is not available in Multi-character Mode.':
    'Inspiration is not available in Multi-character Mode.',
  'Create a Role Card': 'Create a Role Card',
  'Create your first Role Card and earn gems.':
    'Create your first Role Card and earn gems.',
  Coins: 'Coins',
  'My Coins': 'My Coins',
  'Coins to Gems': 'Coins to Gems',
  'Coin Statement': 'Coin Statement',
  'Exchange Now': 'Exchange Now',
  'Exchanging...': 'Exchanging...',
  'Confirm Exchange': 'Confirm Exchange',
  'Creator Income': 'Creator Income',
  'Gems Exchange': 'Gems Exchange',
  'Activity Rewards': 'Activity Rewards',
  Transaction: 'Transaction',
  'No transaction records': 'No transaction records',
  'Load More': 'Load More',
  'Please enter a valid amount': 'Please enter a valid amount',
  'Please enter a positive integer': 'Please enter a positive integer',
  'Please enter a valid amount within your balance.':
    'Please enter a valid amount within your balance.',
  'Not enough coins for exchange': 'Not enough coins for exchange',
  'Exchange failed. Please try again later':
    'Exchange failed. Please try again later',
  'Please login to view the coins page': 'Please login to view the coins page',
  'You will exchange {{amount}} coins for gems':
    'You will exchange {{amount}} coins for gems',
  'Successfully exchanged {{amount}} coins for {{gems}} gems':
    'Successfully exchanged {{amount}} coins for {{gems}} gems',
  'Enter the number of gold coins and the gems will be automatically settled':
    'Enter the number of gold coins and the gems will be automatically settled',
  "Tipsy Coin is a virtual currency created to reward and inspire outstanding creators. You'll receive 3% of the gems consumed by others in your story—delivered to you in the form of Coins.":
    "Tipsy Coin is a virtual currency created to reward and inspire outstanding creators. You'll receive 3% of the gems consumed by others in your story—delivered to you in the form of Coins.",
  'Coins can currently be exchanged for red gems at a 1:1 ratio, or saved for future use. In the future, coins may be redeemable for real cash rewards—stay tuned!':
    'Coins can currently be exchanged for red gems at a 1:1 ratio, or saved for future use. In the future, coins may be redeemable for real cash rewards—stay tuned!',
  'Coins Exchanged': 'Coins Exchanged',
  'Auto-Create Images is enabled': 'Auto-Create Images is enabled',
  'Try Our Best Model': 'Try Our Best Model',
  'Chat once with any model from the Top Pick lineup. Discover the power of our best models!':
    'Chat once with any model from the Top Pick lineup. Discover the power of our best models!',
  'Generate an Image': 'Generate an Image',
  'Generate a Video': 'Generate a Video',
  'Generating an image from this message will cost 20 Gems.':
    'Generating an image from this message will cost 20 Gems.',
  'Generating an image from this message will cost {{gems}} Gems.':
    'Generating an image from this message will cost {{gems}} Gems.',
  'Generating a video from this message will cost 100 Gems.':
    'Generating a video from this message will cost 100 Gems.',
  'Generating a video from this message will cost {{gems}} Gems.':
    'Generating a video from this message will cost {{gems}} Gems.',
  'Create an Interactive Video': 'Create an Interactive Video',
  'Upload a role card with an image to generate an interactive video with your character.':
    'Upload a role card with an image to generate an interactive video with your character.',
  'No chat detected. Please start a chat with a character to generate video.':
    'No chat detected. Please start a chat with a character to generate video.',
  'Create Role Card Required': 'Create Role Card Required',
  'To generate video, you need to create a Role Card for this character first.':
    'To generate video, you need to create a Role Card for this character first.',
  'Add Image Required': 'Add Image Required',
  'To generate video, the Role Card needs to have an image.':
    'To generate video, the Role Card needs to have an image.',
  'Please upload a role card with an image before starting this task.':
    'Please upload a role card with an image before starting this task.',
  'Add Image': 'Add Image',
  'Top Up': 'Top Up',
  'Create Role Card': 'Create Role Card',
  'Create a Video': 'Create a Video',
  'Use a role card with an image to start chatting. After generating a video, come back to claim your gem reward.':
    'Use a role card with an image to start chatting. After generating a video, come back to claim your gem reward.',
  'Upload Now!': 'Upload Now!',
  'Your role card is missing or incomplete! Please upload a role card with a photo to complete this task.':
    'Your role card is missing or incomplete! Please upload a role card with a photo to complete this task.',
  'Generate an interactive video with your character.':
    'Generate an interactive video with your character.',
  'Turn on Auto Image Generation to create one image.':
    'Turn on Auto Image Generation to create one image.',
  'Live Studio Update': 'Live Studio Update',
  'Now you can auto-generate images, auto-create videos, and access all your past creations — all in one place.':
    'Now you can auto-generate images, auto-create videos, and access all your past creations — all in one place.',
  'Tap the button and start creating instantly!':
    'Tap the button and start creating instantly!',
  'Try Now !': 'Try Now !',
  'Try it Now': 'Try it Now',
  'Turn off the background sound of the video here.':
    'Turn off the background sound of the video here.',
  Pin: 'Pin',
  Unpin: 'Unpin',
  Unpinned: 'Unpinned',
  'Auto image generation is off by default for your first experience.':
    'Auto image generation is off by default for your first experience.',
  Notice: 'Notice',
  'No chat detected. Please start a chat to try Auto Image Generation and complete the task to claim gems.':
    'No chat detected. Please start a chat to try Auto Image Generation and complete the task to claim gems.',
  'Got it!': 'Got it!',
  'Chat Bubble Style': 'Chat Bubble Style',
  'Default Color': 'Default Color',
  'Theme Color': 'Theme Color',
  White: 'White',
  Black: 'Black',
  'Font Size': 'Font Size',
  Small: 'Small',
  Medium: 'Medium',
  Large: 'Large',
  'This is a chat message preview where you can see how different font sizes will look.':
    'This is a chat message preview where you can see how different font sizes will look.',
  'Tap each font size to switch, and confirm to apply it to all chats.':
    'Tap each font size to switch, and confirm to apply it to all chats.',
  'Choose the font size you prefer to display your messages.':
    'Choose the font size you prefer to display your messages.',
  'name this memory before you save it': 'name this memory before you save it',
  'Creator support': 'Creator support',
  'Feedback on character creation features':
    'Feedback on character creation features',
  'Tell others about yourself': 'Tell others about yourself',
  'characters max': 'characters max',
  'Enter your name': 'Enter your name',
  'Profile updated successfully': 'Profile updated successfully',
  'Saving...': 'Saving...',
  'Save Changes': 'Save Changes',
  'My Bio': 'My Bio',
  "You haven't added a bio yet—let others discover the real you!":
    "You haven't added a bio yet—let others discover the real you!",
  'Memory & Model': 'Memory & Model',
  'Apply to all characters': 'Apply to all characters',
  'If you turn this off, this memory change only applies to this character.':
    'If you turn this off, this memory change only applies to this character.',
  'Turn off "Apply to all characters": The system will ask for confirmation. After turning it off, any Max Memory Limit changes for this character become an exclusive setting and will not affect other characters.':
    'Turn off "Apply to all characters": The system will ask for confirmation. After turning it off, any Max Memory Limit changes for this character become an exclusive setting and will not affect other characters.',
  'Turn on "Apply to all characters": This character returns to global mode. After saving, the current memory limit syncs to all your characters.':
    'Turn on "Apply to all characters": This character returns to global mode. After saving, the current memory limit syncs to all your characters.',
  'Currently Used': 'Currently Used',
  'Max Memory Limit': 'Max Memory Limit',
  "This'll only apply to this simulator game":
    "This'll only apply to this simulator game",
  'gems/10,000 token': 'gems/10,000 token',
  'Max Memory': 'Max Memory',
  'gems/message': 'gems/message',
  Min: 'Min',
  'Warning: Lower than current usage may affect memory.':
    'Warning: Lower than current usage may affect memory.',
  'This story has a minimum memory limit. You need to select a value greater than {{min}}K':
    'This story has a minimum memory limit. You need to select a value greater than {{min}}K',
  'This character has a minimum memory limit. You need to select a value greater than {{min}}K':
    'This character has a minimum memory limit. You need to select a value greater than {{min}}K',
  'Messages consume gems based on model. Different models support different maximum memory limits.':
    'Messages consume gems based on model. Different models support different maximum memory limits.',
  'You’ve reached your memory limit. Slide the bar to increase the maximum memory.':
    'You’ve reached your memory limit. Slide the bar to increase the maximum memory.',
  'Longer responses use more tokens and cost more gems.':
    'Longer responses use more tokens and cost more gems.',
  'Auto Message Length': 'Auto Message Length',
  'Enabling this allows the model to determine the ideal response length based on context, focusing on quality instead of length.':
    'Enabling this allows the model to determine the ideal response length based on context, focusing on quality instead of length.',
  'Free under 8K': 'Free under 8K',
  'What is Memory?': 'What is Memory?',
  "On Tipsy, Memory is measured in tokens. A token is a small unit of text (like a word fragment) that counts toward how much memory is used. This includes your messages, and the bot's replies.":
    "On Tipsy, Memory is measured in tokens. A token is a small unit of text (like a word fragment) that counts toward how much memory is used. This includes your messages, and the bot's replies.",
  'Two Types of Memory': 'Two Types of Memory',
  'Your Current Memory Usage': 'Your Current Memory Usage',
  'The actual tokens being used from your ongoing conversation.':
    'The actual tokens being used from your ongoing conversation.',
  'This is the number directly linked to gem consumption.':
    'This is the number directly linked to gem consumption.',
  'It always stays at or below your Max Memory Limit setting.':
    'It always stays at or below your Max Memory Limit setting.',
  'The maximum limit you allow the chat to remember.':
    'The maximum limit you allow the chat to remember.',
  'This is a cap you choose (e.g. 20k, 50k, 100k tokens).':
    'This is a cap you choose (e.g. 20k, 50k, 100k tokens).',
  'This does not decide gem cost. It only restricts how far memory can grow.':
    'This does not decide gem cost. It only restricts how far memory can grow.',
  'Your Current Memory Usage will never exceed this cap.':
    'Your Current Memory Usage will never exceed this cap.',
  Overview: 'Overview',
  'Factors that affect gem cost': 'Factors that affect gem cost',
  'Model chosen:': 'Model chosen:',
  'Your Current Memory Usage:': 'Your Current Memory Usage:',
  "The tokens from your messages and the bot's replies count toward Your Current Memory Usage, so the bot's Maximum Reply Length setting will also affect gem cost.":
    "The tokens from your messages and the bot's replies count toward Your Current Memory Usage, so the bot's Maximum Reply Length setting will also affect gem cost.",
  'Model Cost Reference Table': 'Model Cost Reference Table',
  'Model Rate': 'Model Rate',
  'Minimum Cost': 'Minimum Cost',
  Formula: 'Formula',
  'Example (Top Pick)': 'Example (Top Pick)',
  'Unlike most platforms, we calculate gem cost from the exact tokens you use. No fixed tiers, no overcharges!!':
    'Unlike most platforms, we calculate gem cost from the exact tokens you use. No fixed tiers, no overcharges!!',
  "On Tipsy, the gem cost of your chats depends on two main factors: The gem cost depends on the model you choose and Your Current Memory Usage (tokens), which includes your messages and the bot's replies.":
    "On Tipsy, the gem cost of your chats depends on two main factors: The gem cost depends on the model you choose and Your Current Memory Usage (tokens), which includes your messages and the bot's replies.",
  'Model Rate is the gem cost per 10,000 tokens used, while Minimum Cost is the lowest number of gems charged for any single message.':
    'Model Rate is the gem cost per 10,000 tokens used, while Minimum Cost is the lowest number of gems charged for any single message.',
  'Model Name': 'Model Name',
  'If your message uses 4,000 tokens:': 'If your message uses 4,000 tokens:',
  'Formula = 4,000 ÷ 10,000 × 20 = 8 gems.':
    'Formula = 4,000 ÷ 10,000 × 20 = 8 gems.',
  "But since the model's minimum is 10 gems, you'll be charged 10 gems.":
    "But since the model's minimum is 10 gems, you'll be charged 10 gems.",
  'If your message uses 12,000 tokens:': 'If your message uses 12,000 tokens:',
  'Formula = 12,000 ÷ 10,000 × 20 = 24 gems.':
    'Formula = 12,000 ÷ 10,000 × 20 = 24 gems.',
  "Since this is above the minimum, you'll be charged 24 gems.":
    "Since this is above the minimum, you'll be charged 24 gems.",
  'Each model has a different token rate (e.g., Grok4, Wine, Rum) and minimum cost.':
    'Each model has a different token rate (e.g., Grok4, Wine, Rum) and minimum cost.',
  "Or the model's minimum set cost. This is still cheaper than fixed-tier systems!":
    "Or the model's minimum set cost. This is still cheaper than fixed-tier systems!",
  'Estimated Gems = Your Current Memory Usage (tokens) ÷ 10,000 × Model Rate':
    'Estimated Gems = Your Current Memory Usage (tokens) ÷ 10,000 × Model Rate',
  'Model Rate:': 'Model Rate:',
  'Minimum Cost:': 'Minimum Cost:',
  '20 gems per 10,000 tokens.': '20 gems per 10,000 tokens.',
  '10 gems per message.': '10 gems per message.',
  'View details': 'View details',
  'Estimated Next Message:': 'Estimated Next Message:',
  "The tokens from your messages, multi-character background, and the bot's replies count toward Your Current Memory Usage, so the bot's Maximum Reply Length setting will also affect gem cost.":
    "The tokens from your messages, multi-character background, and the bot's replies count toward Your Current Memory Usage, so the bot's Maximum Reply Length setting will also affect gem cost.",
  "On Tipsy, Memory is measured in tokens. A token is a small unit of text (like a word fragment) that counts toward how much memory is used. This includes your messages, multi-character background and the bot's replies.":
    "On Tipsy, Memory is measured in tokens. A token is a small unit of text (like a word fragment) that counts toward how much memory is used. This includes your messages, multi-character background and the bot's replies.",
  'The actual tokens being used from your ongoing conversation and multi-character background.':
    'The actual tokens being used from your ongoing conversation and multi-character background.',
  'For multi-character, the minimum Max Memory is based on the background tokens and cannot be set lower. (This amount varies by multi-character.)':
    'For multi-character, the minimum Max Memory is based on the background tokens and cannot be set lower. (This amount varies by multi-character.)',
  'Multi-character costs differ. Pick a model for the best experience!':
    'Multi-character costs differ. Pick a model for the best experience!',
  'Message Cost': 'Message Cost',
  'Gem History': 'Gem History',
  'Gem History is under construction. For now, only message consumption is available.':
    'Gem History is under construction. For now, only message consumption is available.',
  'No gem activity yet': 'No gem activity yet',
  "Empty. You haven't followed anyone yet.":
    "Empty. You haven't followed anyone yet.",
  '1st Anniversary Sale: Get Triple Gems Now!':
    '1st Anniversary Sale: Get Triple Gems Now!',
  '1st Anniversary Sale: Get Triple Gems Now!\nEnds on Oct 31':
    '1st Anniversary Sale: Get Triple Gems Now!\nEnds on Oct 31',
  'Create characters with tag Halloween 2025 to join!':
    'Create characters with tag Halloween 2025 to join!',
  'Time：10/22-10/31': 'Time：10/22-10/31',
  'See details in your notifications.': 'See details in your notifications.',
  Anniversary: 'Anniversary',
  '1st Year Anniversary': '1st Year Anniversary',
  'Get Triple Gems!': 'Get Triple Gems!',
  'Upgrade to an Annual Plan to save more and earn bonus Gems!':
    'Upgrade to an Annual Plan to save more and earn bonus Gems!',
  '1st Anniversary Sale': '1st Anniversary Sale',
  'Get Triple Gems Now!': 'Get Triple Gems Now!',
  'Up to': 'Up to',
  gems: 'gems',
  'Upgrade to an Annual Plan to earn triple gems!':
    'Upgrade to an Annual Plan to earn triple gems!',
  'Biggest Deal Ever!': 'Biggest Deal Ever!',
  'Annual Plan Sale!': 'Annual Plan Sale!',
  'Tipsy Coin is a virtual currency designed to reward and support outstanding creators. You will receive 5% of the gems spent by others on your content, delivered to you in the form of Coins.':
    'Tipsy Coin is a virtual currency designed to reward and support outstanding creators. You will receive 5% of the gems spent by others on your content, delivered to you in the form of Coins.',
  'Coins can be converted into cash at a rate of 400:1, or exchanged into gems at a 1:1 rate.':
    'Coins can be converted into cash at a rate of 400:1, or exchanged into gems at a 1:1 rate.',
  'Note: If your multi-character story includes characters created by other creators, the Coins earned from that story will be shared proportionally based on each character’s involvement.':
    'Note: If your multi-character story includes characters created by other creators, the Coins earned from that story will be shared proportionally based on each character’s involvement.',
  Publish: 'Publish',
  Published: 'Published',
  'Publishing...': 'Publishing...',
  'Video published': 'Video published',
  'Failed to publish video, please try again':
    'Failed to publish video, please try again',
  'No bio yet. Add one now.': 'No bio yet. Add one now.',
  'Download and save chats': 'Download and save chats',
  'Choose at least 1 and at most 20': 'Choose 1–20 messages',
  'messages have been selected': 'messages have been selected',
  'Choose the duration': 'Choose the duration',
  '8s/300gems': '8s/300gems',
  'There is already a reel being generated.':
    'There is already a reel being generated.',
  'Generate Reel Description':
    'Select 1–20 messages to turn your chat into a short Reel. Each video is 8 seconds and costs 300 Gems.',
  'Create characters using Celebrity': 'Create characters using Celebrity',
  'Enemy to Lovers': 'Enemy to Lovers',
  'Lore to win Premium Membership': 'Lore to win Premium Membership',
  'I agree to have this video join the contest once published.':
    'I agree to have this video join the contest once published.',
  'Create characters using\n Celebrity, Lore or Enemy \nto Lovers tags to win':
    'Create characters using\n Celebrity, Lore or Enemy \nto Lovers tags to win',
  'Premium Membership.': 'Premium Membership.',
  'This feature is only available for Premium members and above':
    'This feature is only available for Premium members and above',
  'These gems are valid for 24 hours. Please use them soon~':
    'These gems are valid for 24 hours. Please use them soon~',
  'Tap to change background': 'Tap to change background',
  'Black Friday Monthly Sale': 'Black Friday Monthly Sale',
  'Get Bonus Gems!': 'Get Bonus Gems!',
  'Get up to 4K bonus Gems when you subscribe to a monthly plan':
    'Get up to 4K bonus Gems when you subscribe to a monthly plan',
  'Black Friday Sale：': 'Black Friday Sale：',
  'Black Friday Sale': 'Black Friday Sale',
  'Black Friday ': 'Black Friday ',
  'New Year Annual Deal': 'New Year Annual Deal',
  'New Year, New Beginning.': 'New Year, New Beginning.',
  'Kick Off the New Year with Triple Bonus Gems!':
    'Kick Off the New Year with Triple Bonus Gems!',
  'UTC 1/21 00:00 - 2/1 00:00': 'UTC 1/21 00:00 - 2/1 00:00',
  januaryAnnualCountdownText: 'New Year Annual Plan Sale! Ends in ',
  annualPlanCountdownText: 'Annual Plan Sale! Ends in ',
  'Monthly Plan Sale': 'Monthly Plan Sale',
  'Get 4K bonus Gems!': 'Get 4K bonus Gems!',
  'Chat & gain relationships with your favorite character.':
    'Chat & gain relationships with your favorite character.',
  'Top ': 'Top ',
  ' winner ': ' winner ',
  ' Gems prize pool.': ' Gems prize pool.',
  '11/24-12/01': '11/24-12/01',
  'They wrote something to you': 'They wrote something to you',
  'View now': 'View now',
  'You unlocked a Letter': 'You unlocked a Letter',
  'What they wrote to you': 'What they wrote to you',
  'Our shared memory': 'Our shared memory',
  'Relationship points x{{num}}': 'Relationship points x{{num}}',
  'A shared memory is now yours': 'A shared memory is now yours',
  'You unlocked a Memoir': 'You unlocked a Memoir',
  'Peek at their inner thoughts': 'Peek at their inner thoughts',
  'You unlocked an Inner Thought': 'You unlocked an Inner Thought',
  'A past event has been revealed': 'A past event has been revealed',
  'You unlocked a special episode together!':
    'You unlocked a special episode together!',
  'Generating content...': 'Generating content...',
  'Please check back later': 'Please check back later',
  'What they truly feel': 'What they truly feel',
  'A story from their past': 'A story from their past',
  'You caught a glimpse of their dream': 'You caught a glimpse of their dream',
  'You unlocked a Dream': 'You unlocked a Dream',
  'Dream Fragments': 'Dream Fragments',
  "🔔Tip: You'll find it later on the character's main page.":
    "🔔Tip: You'll find it later on the character's main page.",
  'Relationship points': 'Relationship points',
  'Points system': 'Points system',
  Multiplier: 'Multiplier',
  Models: 'Models',
  Notes: 'Notes',
  'Free model': 'Free model',
  'Using the free model will not increase relationship points':
    'Using the free model will not increase relationship points',
  'Standard growth rate': 'Standard growth rate',
  'Faster growth': 'Faster growth',
  'High growth': 'High growth',
  'Maximum growth rate': 'Maximum growth rate',
  "Different chat models give different growth rates for relationship points. On our platform, a relationship level reflects how close you've become with a character through chatting. For more details, please see the ":
    "Different chat models give different growth rates for relationship points. On our platform, a relationship level reflects how close you've become with a character through chatting. For more details, please see the ",
  'Relationship System Guide.': 'Relationship System Guide.',
  Journal: 'Journal',
  Episodes: 'Episodes',
  Monologue: 'Monologue',
  Events: 'Events',
  'Inner World': 'Inner World',
  'Unlock when Relationship': 'Unlock when Relationship',
  reaches: 'reaches',
  'Notice!': 'Notice!',
  'Relationship system locked. Chat with the character to unlock it!':
    'Relationship system locked. Chat with the character to unlock it!',
  'Exclusive Relationship Unlocked! ': 'Exclusive Relationship Unlocked! ',
  'Experience the full relationship in the app':
    'Experience the full relationship in the app',
  "Your bond with this character will now grow through every interaction, unlocking more special rewards and experiences along the way. You can always check your progress and rewards on the character's main page. More ways to grow your relationship are coming soon.":
    "Your bond with this character will now grow through every interaction, unlocking more special rewards and experiences along the way. You can always check your progress and rewards on the character's main page. More ways to grow your relationship are coming soon.",
  "Every interaction with this character will strengthen your bond and unlock unique memories and rewards. You can always check your progress and rewards on the character's main page. More ways to grow your relationship are coming soon.":
    "Every interaction with this character will strengthen your bond and unlock unique memories and rewards. You can always check your progress and rewards on the character's main page. More ways to grow your relationship are coming soon.",
  'Because your Relationship Level with {{nickname}} has reached lv.{{newLevel}}, {{nickname}} has gifted you {{gemValue}} gems.':
    'Because your Relationship Level with {{nickname}} has reached lv.{{newLevel}}, {{nickname}} has gifted you {{gemValue}} gems.',
  "You've earned a reward! Claim it on the Relationship Page.":
    "You've earned a reward! Claim it on the Relationship Page.",
  Relationship: 'Relationship',
  'Turning this off will stop your relationship level from increasing for this character. Are you sure you want to continue?':
    'Turning this off will stop your relationship level from increasing for this character. Are you sure you want to continue?',
  'Settings updated successfully': 'Settings updated successfully',
  'Failed to update settings': 'Failed to update settings',
  'Remove Watermark': 'Remove Watermark',
  '(Subscribers Only)': '(Subscribers Only)',
  'Preparing content, please wait...': 'Preparing content, please wait...',
  'The Hug We Shared': 'The Hug We Shared',
  'The Kiss We Shared': 'The Kiss We Shared',
  'The Wedding We Shared': 'The Wedding We Shared',
  'Romantic Moment': 'Romantic Moment',
  'Task Reward': 'Task Reward',
  'Blue Gem Expiration': 'Blue Gem Expiration',
  'Event Gift': 'Event Gift',
  'Story Message': 'Story Message',
  Audio: 'Audio',
  'Auto-Create Image': 'Auto-Create Image',
  'Image Generation': 'Image Generation',
  'World Image Generation': 'World Image Generation',
  'Auto-Create Video': 'Auto-Create Video',
  'Apple Store Purchase': 'Apple Store Purchase',
  Membership: 'Membership',
  'Google Play Purchase': 'Google Play Purchase',
  "Cannot make public: this story includes another user's character.":
    "Cannot make public: this story includes another user's character.",
  "Stories with other users' characters can only be private.":
    "Stories with other users' characters can only be private.",
  "You've run out of gems !": "You've run out of gems !",
  "🔥Bartender's Choice": "🔥Bartender's Choice",
  Minimal: 'Minimal',
  'New-User Subscription Deals starting at $3.9 a month with extra bonus Gems!':
    'New-User Subscription Deals starting at $3.9 a month with extra bonus Gems!',
  'View Subscription Details': 'View Subscription Details',
  'More Ways to Earn Gems': 'More Ways to Earn Gems',
  "You're switched to the Free model to keep chatting (Limited Quality). Explore better models here.":
    "You're switched to the Free model to keep chatting (Limited Quality). Explore better models here.",
  'New User': 'New User',
  'New-User Subscription Deals': 'New-User Subscription Deals',
  'Up to 7.5k Bonus Gems': 'Up to 7.5k Bonus Gems',
  'Just $3.9/Month': 'Just $3.9/Month',
  "You've run out of gems！": "You've run out of gems！",
  'You can upgrade, subscribe, or explore other ways to earn gems.':
    'You can upgrade, subscribe, or explore other ways to earn gems.',
  'You can buy gems or explore other ways to earn them.':
    'You can buy gems or explore other ways to earn them.',
  'Exchange 100 Coins to Gems : {{xx}}/100':
    'Exchange 100 Coins to Gems : {{xx}}/100',
  "Use 100 coins to complete the task. Tap 'Exchange' to learn how to earn and use coins.":
    "Use 100 coins to complete the task. Tap 'Exchange' to learn how to earn and use coins.",
  Exchange: 'Exchange',
  'New-User Subscription Deals!': 'New-User Subscription Deals!',
  "Your relationship level shows how close you've become with a character. Chatting with a character will increase your relationship points. As your level grows, you'll unlock special rewards and experiences.":
    "Your relationship level shows how close you've become with a character. Chatting with a character will increase your relationship points. As your level grows, you'll unlock special rewards and experiences.",
  Stranger: 'Stranger',
  'relationship growth is based on gem consumption. Gem consumption is based on token usage and the selected model.':
    'relationship growth is based on gem consumption. Gem consumption is based on token usage and the selected model.',
  'more ways to increase relationship coming soon.':
    'more ways to increase relationship coming soon.',
  Level: 'Level',
  Reward: 'Reward',
  'Relationship Mystery Rewards': 'Relationship Mystery Rewards',
  Open: 'Open',
  Letter: 'Letter',
  'Inner Thought': 'Inner Thought',
  'Past Event': 'Past Event',
  'Special Episode': 'Special Episode',
  'Memory Pin Limit ↑ + Upcoming': 'Memory Pin Limit ↑ + Upcoming',
  '2000 gems': '2000 gems',
  Memoir: 'Memoir',
  'Usage Notes': 'Usage Notes',
  'There is a toggle to enable or disable the relationship feature in the character chat settings.':
    'There is a toggle to enable or disable the relationship feature in the character chat settings.',
  'Congrats! You got {{amount}} Gems': 'Congrats! You got {{amount}} Gems',
  Mailbox: 'Mailbox',
  Past: 'Past',
  'Days Together': 'Days Together',
  'My Diary Today': 'My Diary Today',
  'Their Diary Today': 'Their Diary Today',
  'Loading diary...': 'Loading diary...',
  'Failed to load diary': 'Failed to load diary',
  'Failed to load their diary': 'Failed to load their diary',
  'No diary for this day yet': 'No diary for this day yet',
  'Their diary is being generated': 'Their diary is being generated',
  'Their diary is queued to generate': 'Their diary is queued to generate',
  'Failed to generate their diary': 'Failed to generate their diary',
  "Scroll down to view today's diary": "Scroll down to view today's diary",
  'Failed to save diary': 'Failed to save diary',
  Meet: 'Meet',
  Days: 'Days',
  days: 'days',
  together: 'together',
  streak: 'streak',
  daysStatsText:
    '<highlight>{{daysTogetherCount}} days</highlight> together, <highlight>{{daysStreakCount}} days</highlight> streak',
  'My Rewards': 'My Rewards',
  "Seeing this means you've made it really far. Don't worry, more high-level rewards are on the way…":
    "Seeing this means you've made it really far. Don't worry, more high-level rewards are on the way…",
  'Heart streak <highlight>{{days}} days</highlight>':
    'Heart streak <highlight>{{days}} days</highlight>',
  'Each day you chat lights up a heart. Keep chatting every day to maintain your streak.':
    'Each day you chat lights up a heart. Keep chatting every day to maintain your streak.',
  Sun: 'Sun',
  Mon: 'Mon',
  Tue: 'Tue',
  Wed: 'Wed',
  Thu: 'Thu',
  Fri: 'Fri',
  Sat: 'Sat',
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  "Write down today's moment and the words you want to keep. Up to 1000 words.":
    "Write down today's moment and the words you want to keep. Up to 1000 words.",
  '{{count}} days streak': '{{count}} days streak',
  'Thank you for your feedback!': 'Thank you for your feedback!',
  'Failed to submit feedback': 'Failed to submit feedback',
  Blocked: 'Blocked',
  'Blocked Users': 'Blocked Users',
  'Hide Others': 'Hide Others',
  'Add users you don’t want to see': 'Add users you don’t want to see',
  'Hide Me': 'Hide Me',
  'Add users you don’t want them to see you':
    'Add users you don’t want them to see you',
  'Enter UID': 'Enter UID',
  'Start New Chat': 'Start New Chat',
  'Start a new chat from here? Your current chat will be saved.':
    'Start a new chat from here? Your current chat will be saved.',
  'Start from here': 'Start from here',
  'View Saved Chats': 'View Saved Chats',
  'Saved Chats': 'Saved Chats',
  'Your conversations with xx.': 'Your conversations with {{name}}.',
  "There's no conversations with xx in your history.":
    "There's no conversations with {{name}} in your history.",
  'Are you sure you want to delete this saved chat?':
    'Are you sure you want to delete this saved chat?',
  'This will permanently delete both chat and Texts conversations.':
    'This will permanently delete both chat and Texts conversations.',
  'Save and Start New Chat': 'Save and Start New Chat',
  'Your current chat will be saved in Saved Chats. Choose where to start for the new chat.':
    'Your current chat will be saved in Saved Chats. Choose where to start for the new chat.',
  'Start Over': 'Start Over',
  'Start from a message': 'Start from a message',
  'Choose a Message': 'Choose a Message',
  'Choose a message to start a new chat. Your current chat will be saved.':
    'Choose a message to start a new chat. Your current chat will be saved.',
  'Save & New Chat': 'Save & New Chat',
  "After Level 100, you'll receive a random gift every time you earn 3000 EXP, including Inner Thoughts, Dreams, Diaries, Letters, or Gems. A secret reward may also await.":
    "After Level 100, you'll receive a random gift every time you earn 3000 EXP, including Inner Thoughts, Dreams, Diaries, Letters, or Gems. A secret reward may also await.",
  'Relationship System Guide': 'Relationship System Guide',
  'What is Relationship Level?': 'What is Relationship Level?',
  "Note: Relationship levels do not affect the character's content or responses.":
    "Note: Relationship levels do not affect the character's content or responses.",
  'Relationship Stages': 'Relationship Stages',
  'There are 100 levels, divided into 5 stages:':
    'There are 100 levels, divided into 5 stages:',
  'still distant from you': 'still distant from you',
  Curious: 'Curious',
  'wants to know you more': 'wants to know you more',
  Drawn: 'Drawn',
  "can't stop thinking about you": "can't stop thinking about you",
  Entangled: 'Entangled',
  "can't pull away from you": "can't pull away from you",
  Fated: 'Fated',
  "believes it's destiny to be with you":
    "believes it's destiny to be with you",
  'How to Increase Relationship?': 'How to Increase Relationship?',
  Chat: 'Chat',
  Upcoming: 'Upcoming',
  Rewards: 'Rewards',
  "Every 5 levels, you'll unlock new rewards, including:":
    "Every 5 levels, you'll unlock new rewards, including:",
  Letters: 'Letters',
  'personal notes from the character': 'personal notes from the character',
  'Past Events': 'Past Events',
  'stories about their background': 'stories about their background',
  'Inner Thoughts': 'Inner Thoughts',
  'secret monologues shared with you': 'secret monologues shared with you',
  'Exclusive Memories': 'Exclusive Memories',
  'special moments capturing your journey':
    'special moments capturing your journey',
  Privileges: 'Privileges',
  'e.g. higher memory pin limit': 'e.g. higher memory pin limit',
  'Reward Overview': 'Reward Overview',
  "Relationship levels do not alter the character's core content, background, or responses.":
    "Relationship levels do not alter the character's core content, background, or responses.",
  "Unlocked rewards stay with you permanently. They won't disappear if your level drops, and they won't be given again when you re-level up.":
    "Unlocked rewards stay with you permanently. They won't disappear if your level drops, and they won't be given again when you re-level up.",
  'Max level is Lv.100. Further levels coming soon.':
    'Max level is Lv.100. Further levels coming soon.',
  'Please select at least one message': 'Please select at least one message',
  'TXT saved successfully': 'TXT saved successfully',
  'Save canceled': 'Save canceled',
  Downloading: 'Downloading',
  'Save failed': 'Save failed',
  'Unlimited messages in trial...': 'Unlimited messages in trial...',
  Send: 'Send',
  'Share Messages': 'Share Messages',
  'Share Chat': 'Share Chat',
  'Share Character': 'Share Character',
  character_share_message:
    "I'm having fun chatting with AI friends on Tipsy, come try it too~",
  'Everything said is generated by AI': 'Everything said is generated by AI',
  'Invalid link. Please check the URL and ensure it matches the supported platform.':
    'Invalid link. Please check the URL and ensure it matches the supported platform.',
  'Name is required': 'Name is required',
  'Gender is required': 'Gender is required',
  'Name should be less than 50 characters':
    'Name should be less than 50 characters',
  'Inappropriate content detected.': 'Inappropriate content detected.',
  'Please try again later': 'Please try again later',
  "On Tipsy, the gem cost of your chats depends on two main factors: The gem cost depends on the model you choose and Your Current Memory Usage (tokens), which includes your messages, character background, pinned memory, and the bot's replies.":
    "On Tipsy, the gem cost of your chats depends on two main factors: The gem cost depends on the model you choose and Your Current Memory Usage (tokens), which includes your messages, character background, pinned memory, and the bot's replies.",
  "The tokens from your messages, character background, pinned memory, and the bot's replies count toward Your Current Memory Usage, so the bot's Maximum Reply Length setting will also affect gem cost.":
    "The tokens from your messages, character background, pinned memory, and the bot's replies count toward Your Current Memory Usage, so the bot's Maximum Reply Length setting will also affect gem cost.",
  '3 gems per message.': '3 gems per message.',
  'If your message uses 1,000 tokens:': 'If your message uses 1,000 tokens:',
  NSFW: 'NSFW',
  "Select rating carefully based on character's image and descriptions. NSFW characters will NOT appear by default unless NSFW mode is enabled to include appropriate 18+ content":
    "Select rating carefully based on character's image and descriptions. NSFW characters will NOT appear by default unless NSFW mode is enabled to include appropriate 18+ content",
  Sound: 'Sound',
  'Loading...': 'Loading...',
  'Layout Customize': 'Layout Customize',
  'Draft Box': 'Draft Box',
  'No drafts': 'No drafts',
  'Load failed': 'Load failed',
  'Deleted successfully': 'Deleted successfully',
  'Failed to save': 'Failed to save',
  'Multi-character stories are currently only available in English. More languages coming soon!':
    'Multi-character stories are currently only available in English. More languages coming soon!',
  'Write the opening scenario. Use asterisks for narration and "quotes" for dialogue (e.g., *She enters.* "Hello.").':
    'Write the opening scenario. Use asterisks for narration and "quotes" for dialogue (e.g., *She enters.* "Hello.").',
  'You can only select up to 10 tags': 'You can only select up to 10 tags',
  'Add Characters': 'Add Characters',
  'Swipe left to view the full-screen image. Tap the image for more options.':
    'Swipe left to view the full-screen image. Tap the image for more options.',
  'Swipe left to view the full-screen video. Tap the video for more options.':
    'Swipe left to view the full-screen video. Tap the video for more options.',
  "You're switched to the Free model to keep chatting(Limited Quality). Explore better models here.":
    "You're switched to the Free model to keep chatting(Limited Quality). Explore better models here.",
  'Toggle Auto Mode': 'Toggle Auto Mode',
  'Turn Off': 'Turn Off',
  'Connect Tipsy & {{typeName}}': 'Connect Tipsy & {{typeName}}',
  'Please click here to link your "{{typeName}}" account to Tipsy.':
    'Please click here to link your "{{typeName}}" account to Tipsy.',
  'If you have any questions, please contact us.':
    'If you have any questions, please contact us.',
  'Link Now': 'Link Now',
  'Copy Link': 'Copy Link',
  'Unpinned successfully': 'Unpinned successfully',
  'Pinned successfully': 'Pinned successfully',
  'Unpinned failed': 'Unpinned failed',
  'Pinned failed': 'Pinned failed',
  'Up to 3 pins allowed. Unpin one to try again.':
    'Up to 3 pins allowed. Unpin one to try again.',
  'Claim reward successfully': 'Claim reward successfully',
  'Claim reward failed': 'Claim reward failed',
  'The reward has been compensated as gems.':
    'The reward has been compensated as gems.',
  'Congratulations!': 'Congratulations!',
  'Pin Memory limit increased! You can now pin more memories in chat for a more immersive experience.':
    'Pin Memory limit increased! You can now pin more memories in chat for a more immersive experience.',
  'You can only select up to 20 characters':
    'You can only select up to 20 characters',
  'You can only select up to 21 characters':
    'You can only select up to 21 characters',
  'No Public Characters': 'No Public Characters',
  'Create and Publish your reels to win':
    'Create and Publish your reels to win',
  'Deluxe membership!': 'Deluxe membership!',
  '11/10-11/23': '11/10-11/23',
  'Halloween 2025': 'Halloween 2025',
  'New Tags': 'New Tags',
  'Create Reels Contest': 'Create Reels Contest',
  'Report submitted successfully': 'Report submitted successfully',
  'Failed to submit report': 'Failed to submit report',
  'Please select one option': 'Please select one option',
  'Claim now': 'Claim now',
  'Relationship Level': 'Relationship Level',
  'Reset Relationship Level': 'Reset Relationship Level',
  'Are you sure? The Relationship Level in this chat will be reset to the beginning.':
    'Are you sure? The Relationship Level in this chat will be reset to the beginning.',
  'Your Relationship Level will reset to the beginning in the new chat.':
    'Your Relationship Level will reset to the beginning in the new chat.',
  '4K': '4K',
  '2M': '2M',
  'Estimated gem cost changes based on your memory usage and the model you choose. View details for more info.':
    'Estimated gem cost changes based on your memory usage and the model you choose. View details for more info.',
  Success: 'Success',
  "Add users you don't want them to see you":
    "Add users you don't want them to see you",
  'Remove from favorites': 'Remove from favorites',
  'Add to favorites': 'Add to favorites',
  'Unknown date': 'Unknown date',
  'Claim failed': 'Claim failed',
  'Triple Gems (Only During 1st Anniversary)':
    'Triple Gems (Only During 1st Anniversary)',
  'This feature is only available for Standard members and above':
    'This feature is only available for Standard members and above',
  'Subscribe Now': 'Subscribe Now',
  Restore: 'Restore',
  'Restore draft': 'Restore',
  'Black Friday Sale:': 'Black Friday Sale:',
  'Limited Time': 'Limited Time',
  'UTC 11/24 00:00 - 12/01 00:00': 'UTC 11/24 00:00 - 12/01 00:00',
  '11/24 - 12/01': '11/24 - 12/01',
  '11/10-11/24': '11/10-11/24',
  'Follow failed:': 'Follow failed:',
  'Deletion failure': 'Deletion failure',
  'Setting Failed': 'Setting Failed',
  'Save success': 'Save success',
  'Settings saved': 'Settings saved',
  'With an {{memory}} memory limit, each message uses about {{gems}} gems':
    'With an {{memory}} memory limit, each message uses about {{gems}} gems',
  Downloaded: 'Downloaded',
  'Upload Failed': 'Upload Failed',
  'No more records': 'No more records',
  'watermark switch': 'watermark switch',
  Password: 'Password',
  'Not Available Email': 'Not Available Email',
  'Download App': 'Download App',
  'In use': 'In use',
  'Choose a voice that brings your character to life.':
    'Choose a voice that brings your character to life.',
  'No voices found': 'No voices found',
  'Age must be an integer.': 'Age must be an integer.',
  'Cannot select failed moderation images':
    'Cannot select failed moderation images',
  'Enter your message...': 'Enter your message...',
  'Max Reply Message Length (words)': 'Max Reply Message Length (words)',
  'Max Reply Length (words)': 'Max Reply Length (words)',
  'Failed to collect bonus': 'Failed to collect bonus',
  'Delete This Multi-character?': 'Delete This Multi-character?',
  'No Memory': 'No Memory',
  'Multi-character Introduction': 'Multi-character Introduction',
  'Tell us about yourself...': 'Tell us about yourself...',
  'You’ve made some changes to your role card in role card center. Would you like to update it here too?':
    'You’ve made some changes to your role card in role card center. Would you like to update it here too?',
  Safe: 'Safe',
  "On Tipsy, the gem cost of your chats depends on two main factors: The gem cost depends on the model you choose and Your Current Memory Usage (tokens), which includes your messages, multi-character background, pinned memory, and the bot's replies.":
    "On Tipsy, the gem cost of your chats depends on two main factors: The gem cost depends on the model you choose and Your Current Memory Usage (tokens), which includes your messages, multi-character background, pinned memory, and the bot's replies.",
  "The tokens from your messages, multi-character background, pinned memory, and the bot's replies count toward Your Current Memory Usage, so the bot's Maximum Reply Length setting will also affect gem cost.":
    "The tokens from your messages, multi-character background, pinned memory, and the bot's replies count toward Your Current Memory Usage, so the bot's Maximum Reply Length setting will also affect gem cost.",
  'Formula = 1,000 ÷ 10,000 × 20 = 2 gems':
    'Formula = 1,000 ÷ 10,000 × 20 = 2 gems',
  "But since the model's minimum is 3 gems, you'll be charged 3 gems.":
    "But since the model's minimum is 3 gems, you'll be charged 3 gems.",
  "On Tipsy, Memory is measured in tokens. A token is a small unit of text (like a word fragment) that counts toward how much memory is used. This includes your messages, multi-character background, pinned memory and the bot's replies.":
    "On Tipsy, Memory is measured in tokens. A token is a small unit of text (like a word fragment) that counts toward how much memory is used. This includes your messages, multi-character background, pinned memory and the bot's replies.",
  'The actual tokens being used from your ongoing conversation, multi-character background, and pinned memory.':
    'The actual tokens being used from your ongoing conversation, multi-character background, and pinned memory.',
  "On Tipsy, Memory is measured in tokens. A token is a small unit of text (like a word fragment) that counts toward how much memory is used. This includes your messages, character background, pinned memory and the bot's replies.":
    "On Tipsy, Memory is measured in tokens. A token is a small unit of text (like a word fragment) that counts toward how much memory is used. This includes your messages, character background, pinned memory and the bot's replies.",
  'The actual tokens being used from your ongoing conversation, character background, and pinned memory.':
    'The actual tokens being used from your ongoing conversation, character background, and pinned memory.',
  hello: 'Hello',
  hi: 'Hi',
  'Starting Over': 'Starting Over',
  'Switching accounts (to get gems/rewards)':
    'Switching accounts (to get gems/rewards)',
  'Start fresh (to clear all memory)': 'Start fresh (to clear all memory)',
  'Chat Experience': 'Chat Experience',
  'Archive & History': 'Archive & History',
  'Appearance & Media': 'Appearance & Media',
  'Repetitive or robotic replies': 'Repetitive or robotic replies',
  'Forgets our past conversations': 'Forgets our past conversations',
  'Too slow, laggy, or buggy': 'Too slow, laggy, or buggy',
  'No interesting stories/characters': 'No interesting stories/characters',
  'Lack of voice or visual features': 'Lack of voice or visual features',
  'Price & Gems': 'Price & Gems',
  'Too expensive / Not enough gems': 'Too expensive / Not enough gems',
  'Not worth the subscription': 'Not worth the subscription',
  'Privacy Concerns': 'Privacy Concerns',
  'Worried about data/history leak': 'Worried about data/history leak',
  'Personal Reasons': 'Personal Reasons',
  'Life got busy': 'Life got busy',
  'Just trying it out': 'Just trying it out',
  'Are you open to a follow-up interview?':
    'Are you open to a follow-up interview?',
  'It hurts to see you go. Help us improve for your next visit?':
    'It hurts to see you go. Help us improve for your next visit?',
  'Try on web': 'Try on web',
  'Download on the': 'Download on the',
  'App Store': 'App Store',
  'Google Play': 'Google Play',
  'APK File': 'APK File',
  'Every World Begins with You': 'Every World Begins with You',
  "Whether you're a creator or a dreamer—this is where":
    "Whether you're a creator or a dreamer—this is where",
  'stories are made real in every moment':
    'stories are made real in every moment',
  "Whether you're a creator or a": "Whether you're a creator or a",
  'dreamer—this is where stories are made':
    'dreamer—this is where stories are made',
  'real in every moment': 'real in every moment',
  'Real-time stories': 'Real-time stories',
  'Real-time visuals': 'Real-time visuals',
  'From idea to': 'From idea to',
  'video in seconds': 'video in seconds',
  'From idea to video': 'From idea to video',
  'in seconds': 'in seconds',
  'Fall for the': 'Fall for the',
  'one you create': 'one you create',
  'Create · Interact · Connect': 'Create · Interact · Connect',
  'Join our community': 'Join our community',
  'Business Inquiries: market@tipsy.chat':
    'Business Inquiries: market@tipsy.chat',
  'More >': 'More >',
  'All rights reserved.': 'All rights reserved.',
  'Delete failed': 'Delete failed',
  'Account deleted successfully': 'Account deleted successfully',
  'All Read': 'All Read',
  'All messages marked as read': 'All messages marked as read',
  'No unread messages': 'No unread messages',
  'Operation Failed': 'Operation Failed',
  'Roses for My Valentine': 'Roses for My Valentine',
  "Gift Roses to your Valentine to heat up your relationship 5x faster, and automatically enter the Valentine's Rose Event for a chance to win tons of Gems!":
    "Gift Roses to your Valentine to heat up your relationship 5x faster, and automatically enter the Valentine's Rose Event for a chance to win tons of Gems!",
  'Tap to send 1 Rose, or hold to send more.':
    'Tap to send 1 Rose, or hold to send more.',
  '1 Gem = 1 Rose (+5 Relationship EXP)':
    '1 Gem = 1 Rose (+5 Relationship EXP)',
  "Valentine's": "Valentine's",
  "Valentine's Limited-Time Deals": "Valentine's Limited-Time Deals",
  "Please write your reason. We'll review it carefully.":
    "Please write your reason. We'll review it carefully.",
  'Please enter additional details': 'Please enter additional details',
  Roses: 'Roses',
  Flowers: 'Flowers',
  'Your Relationship Level has reached {{level}}. The Character Diary feature is now unlocked. Start recording your days together.':
    'Your Relationship Level has reached {{level}}. The Character Diary feature is now unlocked. Start recording your days together.',
  Yes: 'Yes',
  No: 'No',
  'Meet <highlight>{{days}}</highlight> Days':
    'Meet <highlight>{{days}}</highlight> Days',
  'Now your character can write in the diary with you, too. Check it out on the Relationship Page.':
    'Now your character can write in the diary with you, too. Check it out on the Relationship Page.',
  'App Not Installed': 'App Not Installed',
  'Click the button below to open in web browser':
    'Click the button below to open in web browser',
  'Open in Browser': 'Open in Browser',
  'Link copied, opening {{platform}}...':
    'Link copied, opening {{platform}}...',
  'Checking content compliance': 'Checking content compliance',
  'Share content contains sensitive information':
    'Share content contains sensitive information',
  'Generating preview...': 'Generating preview...',
  'Failed to generate preview image': 'Failed to generate preview image',
  'Tap anywhere to close': 'Tap anywhere to close',
  'Hot Comments🔥': 'Hot Comments🔥',
  'Write the First Comment': 'Write the First Comment',
  'Comment Now': 'Comment Now',
  Comments: 'Comments',
  'View Original': 'View Original',
  'View Translation': 'View Translation',
  'Reply @{{nickname}}': 'Reply @{{nickname}}',
  Refresh: 'Refresh',
  'Share your thoughts here': 'Share your thoughts here',
  Reply: 'Reply',
  'View All': 'View All ',
  Easter: 'Easter',
  'Easter Bundles End In': 'Easter Bundles End In',
  Spring: 'Spring',
  'Spring Bundles End In': 'Spring Bundles End In',
  'Lucky Clover for Spring': 'Lucky Clover for Spring',
  "Gift Golden Easter Eggs to level up your relationship 5x faster! You'll also auto-enter to win a share of the 250,000+ Gem prize pool!":
    "Gift Golden Easter Eggs to level up your relationship 5x faster! You'll also auto-enter to win a share of the 250,000+ Gem prize pool!",
  'Tap to send a Four-Leaf Clover, or hold to send more.':
    'Tap to send a Four-Leaf Clover, or hold to send more.',
  'Tap to send a Golden Easter Egg, or hold to send more.':
    'Tap to send a Golden Easter Egg, or hold to send more.',
  '1 Gem = 1 Four-Leaf Clover (+5 Relationship EXP)':
    '1 Gem = 1 Four-Leaf Clover (+5 Relationship EXP)',
  '1 Gem = 1 Golden Easter Egg (+5 Rel. EXP)':
    '1 Gem = 1 Golden Easter Egg (+5 Rel. EXP)',
  'Three-Leaf Clover': 'Three-Leaf Clover',
  'Gift Three-Leaf Clovers to grow your relationship faster and unlock more relationship rewards.':
    'Gift Three-Leaf Clovers to grow your relationship faster and unlock more relationship rewards.',
  Clovers: 'Clovers',
  'Golden Easter Eggs': 'Golden Easter Eggs',
  'You found a Lucky 3-Leaf Clover!': 'You found a Lucky 3-Leaf Clover!',
  'Egg-cellent find! You are so lucky! Surprise Easter Eggs drop randomly as you chat. It has been safely tucked into your bottom-right Easter Egg icon, ready to be gifted to ANY character you like.':
    'Egg-cellent find! You are so lucky! Surprise Easter Eggs drop randomly as you chat. It has been safely tucked into your bottom-right Easter Egg icon, ready to be gifted to ANY character you like.',
  'Each 3-Leaf Clover = +5 Relationship EXP':
    'Each 3-Leaf Clover = +5 Relationship EXP',
  'Easter Egg = +5 Relationship EXP': 'Easter Egg = +5 Relationship EXP',
  'Oops! Out of Gems!': 'Oops! Out of Gems!',
  'Looks like you need more Gems for this Golden Egg. Want to grab some now?':
    'Looks like you need more Gems for this Golden Egg. Want to grab some now?',
  'Get Gems': 'Get Gems',
  '1 Gem / Egg': '1 Gem / Egg',
  'Out of Lucky Eggs!': 'Out of Lucky Eggs!',
  'Keep chatting to earn more Lucky Eggs, or use Gems to send a Golden Egg!':
    'Keep chatting to earn more Lucky Eggs, or use Gems to send a Golden Egg!',
  'Congratulations on discovering your surprise.':
    'Congratulations on discovering your surprise.',
  'Tap and hold the bunny ears, then pull up to reveal your Easter surprise!':
    'Tap and hold the bunny ears, then pull up to reveal your Easter surprise!',
  'Keep pulling. Your Easter surprise is on the way.':
    'Keep pulling. Your Easter surprise is on the way.',
  'Pull the bunny ears to open the Easter surprise':
    'Pull the bunny ears to open the Easter surprise',
  'Opening your Easter surprise...': 'Opening your Easter surprise...',
  "Look who's rich! Gem x{{amount}}!": "Look who's rich! Gem x{{amount}}!",
  "You're insanely lucky! Feel free to spend them anywhere you can on the platform!":
    "You're insanely lucky! Feel free to spend them anywhere you can on the platform!",
  'Egg-cellent pull! Lucky Easter Egg x{{amount}}!':
    'Egg-cellent pull! Lucky Easter Egg x{{amount}}!',
  'You can gift them to any character in the chat interface and increase your Relationship Level.':
    'You can gift them to any character in the chat interface and increase your Relationship Level.',
  'You found a LUCKY Easter Egg!': 'You found a LUCKY Easter Egg!',
  'You found a hidden Easter Egg!': 'You found a hidden Easter Egg!',
  '3 eggs are scattered around the app every day! Keep exploring, or send it as a gift to any character in chat.':
    '3 eggs are scattered around the app every day! Keep exploring, or send it as a gift to any character in chat.',
  'If you confirm permanent deletion, your account will be deleted immediately. This action CANNOT be undone. Please proceed with caution':
    'If you confirm permanent deletion, your account will be deleted immediately. This action CANNOT be undone. Please proceed with caution.',
  'Coin Exchange Reward': 'Coin Exchange Reward',
  '({{days}} days left)': '({{days}} days left)',
  '(1 day left)': '(1 day left)',
  Alone: 'Alone',
  'Short Description is required': 'Short Description is required',
  'Visibility is required': 'Visibility is required',
  'Name should be within {{expr}} characters':
    'Name should be within {{expr}} characters',
  'Long Description should be within {{expr}} characters':
    'Long Description should be within {{expr}} characters',
  'Short Description should be within {{expr}} characters':
    'Short Description should be within {{expr}} characters',
  'Select up to 10 relevant tags or keywords':
    'Select up to 10 relevant tags or keywords',
  'Only four styles can be added at most':
    'Only four styles can be added at most',
  'Please keep your input within {{expr}} characters':
    'Please keep your input within {{expr}} characters',
  'Please upload a GIF or WebP image': 'Please upload a GIF or WebP image',
  'Please pick a character display image':
    'Please pick a character display image',
  'Please generate a character display image':
    'Please generate a character display image',
  'No character image': 'No character image',
  'No character face image': 'No character face image',
  'No character gender': 'No character gender',
  'Character updated successfully, id:': 'Character updated successfully, id:',
  'Character created successfully, id:': 'Character created successfully, id:',
  Collapse: 'Collapse',
  Expand: 'Expand',
  'Token:': 'Token:',
  'Consumption:': 'Consumption:',
  'Gift Lucky 4-Leaf Clovers to your character to level up your relationship 5x faster, and auto-enter the Lucky Clover Event to win a share of the 250,000+ Gem prize pool!':
    'Gift Lucky 4-Leaf Clovers to your character to level up your relationship 5x faster, and auto-enter the Lucky Clover Event to win a share of the 250,000+ Gem prize pool!',
  'Lucky 4-Leaf Clovers': 'Lucky 4-Leaf Clovers',
  'Super rare! You are so lucky! 3-Leaf Clovers drop randomly while you chat. It has been safely stored in the bottom-right clover icon, and you can gift it to ANY character you like.':
    'Super rare! You are so lucky! 3-Leaf Clovers drop randomly while you chat. It has been safely stored in the bottom-right clover icon, and you can gift it to ANY character you like.',
  'Looks like you need more Gems for this 4-Leaf Clover. Want to grab some now?':
    'Looks like you need more Gems for this 4-Leaf Clover. Want to grab some now?',
  'Out of 3-Leaf Clovers!': 'Out of 3-Leaf Clovers!',
  'Keep chatting to earn more 3-Leaf Clovers, or use Gems to send a lucky 4-Leaf Clover!':
    'Keep chatting to earn more 3-Leaf Clovers, or use Gems to send a lucky 4-Leaf Clover!',
  'Favorite Moments': 'Favorite Moments',
  'Network Error': 'Network Error',
  'No moments yet': 'No moments yet',
  'No favorite moments': 'No favorite moments',
  'Tell us more... What could we change to make you stay? (e.g., I want the AI to remember more, or gems are too expensive)':
    'Tell us more... What could we change to make you stay? (e.g., I want the AI to remember more, or gems are too expensive)',
  'Please enter a reason': 'Please enter a reason',
  'Report Memory': 'Report Memory',
  Close: 'Close',
  'Open in App': 'Open in App',
  'Failed to upload share image': 'Failed to upload share image',
  'Failed to check content compliance': 'Failed to check content compliance',
  'Invalid media link': 'Invalid media link',
  'Failed to save image': 'Failed to save image',
  'Saving image...': 'Saving image...',
  share_message:
    "I'm having fun chatting with AI friends on Tipsy, come try it too~",
  'Failed to play audio': 'Failed to play audio',
  'Failed to load audio': 'Failed to load audio',
  'Login failed': 'Login failed',
  'Failed to send verification code': 'Failed to send verification code',
  'Failed to load rich content data': 'Failed to load rich content data',
  'Failed to share': 'Failed to share',
  'Remove image': 'Remove image',
  'Switch Character': 'Switch Character',
  'Visit {{expr}}': 'Visit {{expr}}',
  'Only gif can be selected': 'Only gif can be selected',
  'Delete file': 'Delete file',
  'Video not available': 'Video not available',
  'Start Chatting': 'Start Chatting',
  'Rich content': 'Rich content',
  'Shared video': 'Shared video',
  'Link Account failed': 'Link Account failed',
  'Authentication has expired': 'Authentication has expired',
  'Discover Unique AI Characters at Tipsy Chat':
    'Discover Unique AI Characters at Tipsy Chat',
  'Meet captivating personalities, explore their stories, and engage in immersive AI-driven conversations.':
    'Meet captivating personalities, explore their stories, and engage in immersive AI-driven conversations.',
  '2025 Top 12 Most Popular NSFW AI Characters in TipsyChat | NSFW Character AI Alternative':
    '2025 Top 12 Most Popular NSFW AI Characters in TipsyChat | NSFW Character AI Alternative',
  'Discover 2025 Top 12 Most Popular NSFW AI Characters in TipsyChat , where you can engage with diverse experiences and chat with anime characters, ai girlfriends and ai boyfriends. Enjoy complete freedom in NSFW Character AI Alternative and Explore personalized interactions, unique personalities, and explore creative spicy conversations like never before.':
    'Discover 2025 Top 12 Most Popular NSFW AI Characters in TipsyChat , where you can engage with diverse experiences and chat with anime characters, ai girlfriends and ai boyfriends. Enjoy complete freedom in NSFW Character AI Alternative and Explore personalized interactions, unique personalities, and explore creative spicy conversations like never before.',
  Resend: 'Resend',
  Retell: 'Retell',
  'Send another': 'Send another',
  'Insert action text': 'Insert action text',
  'Go back': 'Go back',
  'Send message': 'Send message',
  'Failed to load image': 'Failed to load image',
  'Viewable only after approval.': 'Viewable only after approval.',
  'You can switch to monthly after your current plan expires.':
    'You can switch to monthly after your current plan expires.',
  'Share failed': 'Share failed',
  'Upgrade success': 'Upgrade success',
  'Downloaded successfully': 'Downloaded successfully',
  'Download failed': 'Download failed',
  Unknown: 'Unknown',
  'memory from {{from}} to {{to}}': 'memory from {{from}} to {{to}}',
  Collect: 'Collect',
  'NSFW character and SFW model mismatch.':
    'NSFW character and SFW model mismatch.',
  Uncollect: 'Uncollect',
  'Time :': 'Time :',
  'No images available': 'No images available',
  'Failed to update video setting': 'Failed to update video setting',
  'Failed to update setting': 'Failed to update setting',
  'Start a chat with {{name}} on Tipsy Chat!':
    'Start a chat with {{name}} on Tipsy Chat!',
  'Activity image {{index}}': 'Activity image {{index}}',
  'Live Your Story': 'Live Your Story',
  'My chat with {{name}}': 'My chat with {{name}}',
  'Only one image allowed. Please remove the current image first':
    'Only one image allowed. Please remove the current image first',
  'Please enter comment content': 'Please enter comment content',
  'Posting too frequently': 'Posting too frequently',
  'Comment posted successfully': 'Comment posted successfully',
  'Comment failed, please try again': 'Comment failed, please try again',
  'Crop image': 'Crop image',
  'View more replies': 'View more replies',
  'Collapse all replies': 'Collapse all replies',
  'View all replies': 'View all replies',
  'Like success': 'Like success',
  'Unlike success': 'Unlike success',
  'Translation success': 'Translation success',
  'No permission to delete this comment':
    'No permission to delete this comment',
  'Load more comments': 'Load more comments',
  'Delete this comment?': 'Delete this comment?',
  'Please enter the reason': 'Please enter the reason',
  'Invalid comment': 'Invalid comment',
  'Report Comment': 'Report Comment',
  'Submitting...': 'Submitting...',
  'Report Reason': 'Report Reason',
  'Please describe the issue with this comment':
    'Please describe the issue with this comment',
  Discard: 'Discard',
  'If you exit now, your edits will be discarded':
    'If you exit now, your edits will be discarded',
  '2k Pinned Memory': '2k Pinned Memory',
  '3k Pinned Memory': '3k Pinned Memory',
  '4k Pinned Memory': '4k Pinned Memory',
  characters: 'characters',
  "Anything beyond the limit won't be remembered.":
    "Anything beyond the limit won't be remembered.",
  "Valentine's Deals End In": "Valentine's Deals End In",
  'Daily Egg Smash is temporarily unavailable. Please try again later.':
    'Daily Egg Smash is temporarily unavailable. Please try again later.',
  "The character's memory is full. They might forget earlier details as you continue to chat. To prevent this, you can expand their memory in the Memory & Model settings.\nNote: Using more memory increases the gem cost per message.":
    "The character's memory is full. They might forget earlier details as you continue to chat. To prevent this, you can expand their memory in the Memory & Model settings.\nNote: Using more memory increases the gem cost per message.",
  'Go to Edit': 'Go to Edit',
  'Character Unavailable': 'Character Unavailable',
  'This character has been flagged for content involving minors and is currently unavailable. You can edit and resubmit, or request a manual review.':
    'This character has been flagged for content involving minors and is currently unavailable. You can edit and resubmit, or request a manual review.',
  'Request Review': 'Request Review',
  'Pending Review': 'Pending Review',
  'This character may contain sensitive content and is currently pending review. Once approved, it will be made public and chat will be available. You can also make edits and resubmit.':
    'This character may contain sensitive content and is currently pending review. Once approved, it will be made public and chat will be available. You can also make edits and resubmit.',
  'Character Not Approved': 'Character Not Approved',
  'Our team has completed the review and confirmed the original decision. This character involves minor-related content and is unavailable for chat. Please make the necessary changes and resubmit.':
    'Our team has completed the review and confirmed the original decision. This character involves minor-related content and is unavailable for chat. Please make the necessary changes and resubmit.',
  'Your request for review has been submitted successfully.':
    'Your request for review has been submitted successfully.',
  'Contains Private Characters': 'Contains Private Characters',
  'Contains private characters': 'Contains private characters',
  "Stories containing other users' characters can only be set to private.":
    "Stories containing other users' characters can only be set to private.",
  'User character': 'User character',
  'Apply changes to all chats?': 'Apply changes to all chats?',
  'Your role card has been updated.': 'Your role card has been updated.',
  'Do you want to use this new profile in your other conversations too?':
    'Do you want to use this new profile in your other conversations too?',
  'Apply to All': 'Apply to All',
  Introduction: 'Introduction',
  'Inbox Message': 'Inbox Message',
  Polaroid: 'Polaroid',
  'View Details': 'View Details',
  'Event ends in:': 'Event ends in:',
  'View Full Rankings': 'View Full Rankings',
  'Loading rankings...': 'Loading rankings...',
  'No rankings yet': 'No rankings yet',
  'Unable to load rankings': 'Unable to load rankings',
  'Check Back Tomorrow': 'Check Back Tomorrow',
  'May Ball leaderboard detail': '{{flowers}} flowers + {{photos}} photos',
  'May Ball Character #{{rank}}': 'Character #{{rank}}',
  'May Ball Creator': 'Creator',
  'May Ball Voter #{{rank}}': 'Voter #{{rank}}',
  'Each Flower = 1 Point': 'Each Flower = 1 Point',
  'Send flowers to the one who captures your heart':
    'Send flowers to the one who captures your heart',
  'Hold the flower icon in chat to let your voice be heard':
    'Hold the flower icon in chat to let your voice be heard',
  'Contributes to': 'Contributes to',
  'Top Voter Standings': 'Top Voter Standings',
  'Character Ranking': 'Character Ranking',
  '👑 Candidate Types👑': '👑 Candidate Types👑',
  'Corsages → For Queen candidates': 'Corsages → For Queen candidates',
  'Boutonnières → For King candidates': 'Boutonnières → For King candidates',
  '🌹 Ways to Gather Flowers🌹': '🌹 Ways to Gather Flowers🌹',
  'Daily Check-in +10': 'Daily Check-in +10',
  'Chat Drop +10': 'Chat Drop +10',
  'Gem Packs 400-600': 'Gem Packs 400-600',
  'Send Flowers Now': 'Send Flowers Now',
  'Each Polaroid = 50 Points': 'Each Polaroid = 50 Points',
  'Each Polaroid = 20 Points': 'Each Polaroid = 20 Points',
  'Capture exclusive prom moments': 'Capture exclusive prom moments',
  'with your favorite characters.': 'with your favorite characters.',
  'Turn fleeting memories into something you can keep.':
    'Turn fleeting memories into something you can keep.',
  'A Hidden Moment': 'A Hidden Moment',
  'Awaits...': 'Awaits...',
  '📸 Ways to Get Polaroid📸': '📸 Ways to Get Polaroid📸',
  'Free Shots 3 Per Player': 'Free Shots 3 Per Player',
  'Chat Drop +1 Polaroid': 'Chat Drop +1 Polaroid',
  'Extra Shots 20 Gems Each': 'Extra Shots 20 Gems Each',
  'Take Pictures Now': 'Take Pictures Now',
  'May Ball Character': 'Character',
  'May Ball Moment {{index}}': 'Moment {{index}}',
  '✨Judging Criteria✨': '✨Judging Criteria✨',
  'Final rankings are based on total score:':
    'Final rankings are based on total score:',
  'Flowers + Polaroid bonus': 'Flowers + Polaroid bonus',
  '🎁 Rewards🎁': '🎁 Rewards🎁',
  'Character Rewards': 'Character Rewards',
  'Top 10 Queen & King characters earn an exclusive V-Badge':
    'Top 10 Queen & King characters earn an exclusive V-Badge',
  'Highlight Reward': 'Highlight Reward',
  '#1 Queen & King will be featured in a dedicated award video':
    '#1 Queen & King will be featured in a dedicated award video',
  'Voter Rewards': 'Voter Rewards',
  'Top 100 voters share a total of 221,000 gems':
    'Top 100 voters share a total of 221,000 gems',
  'Creator Rewards': 'Creator Rewards',
  'Top 10 creators share a total of 49,000 gems':
    'Top 10 creators share a total of 49,000 gems',
  'The coronation begins soon...': 'The coronation begins soon...',
  'Your crowned winners will be revealed here':
    'Your crowned winners will be revealed here',
  'Full Experience on App': 'Full Experience on App',
  'Sending flowers and taking Polaroids are currently only supported on the mobile app. Download the App to unlock these features and interact with your partner!':
    'Sending flowers and taking Polaroids are currently only supported on the mobile app. Download the App to unlock these features and interact with your partner!',
  'Start chatting with a character first':
    'Start chatting with a character first',
  'Unable to find a character to chat with':
    'Unable to find a character to chat with',
  'The event has not started yet': 'The event has not started yet',
  'The event has ended': 'The event has ended',
  '1 Gem / Flower': '1 Gem / Flower',
  'Flowers are unavailable right now': 'Flowers are unavailable right now',
  'Failed to send flowers': 'Failed to send flowers',
  'Every Dance Deserves a Flower': 'Every Dance Deserves a Flower',
  'Offer a flower to the one who caught your eye tonight. Each flower deepens your bond and lifts their place on the rankings. 1 Gem per flower.':
    'Offer a flower to the one who caught your eye tonight. Each flower deepens your bond and lifts their place on the rankings. 1 Gem per flower.',
  'Send Flowers': 'Send Flowers',
  'Tap the flower to send 1 Flower, or hold to send more during May Ball.':
    'Tap the flower to send 1 Flower, or hold to send more during May Ball.',
  'Taking Polaroids is currently only supported on the mobile app. Download the App to unlock this feature!':
    'Taking Polaroids is currently only supported on the mobile app. Download the App to unlock this feature!',
  'Reset will clear the current form. Unsaved changes will be lost.':
    'Reset will clear the current form. Unsaved changes will be lost.',
  'Chat Archives': 'Chat Archives',
  'Reset This Chat?': 'Reset This Chat?',
  'All messages in this archive will be permanently deleted.':
    'All messages in this archive will be permanently deleted.',
  'Chat reset successfully.': 'Chat reset successfully.',
  'You can delete Pinned Memories manually if needed.':
    'You can delete Pinned Memories manually if needed.',
  'Save & Switch to New Chat': 'Save & Switch to New Chat',
  'Create New Chat': 'Create New Chat',
  'Choose a starting point. Relationship Level will reset.':
    'Choose a starting point. Relationship Level will reset.',
  'Start from a Message': 'Start from a Message',
  'Begin fresh from the opening.': 'Begin fresh from the opening.',
  'Continue from a past message.': 'Continue from a past message.',
  'Chat Archives Update': 'Chat Archives Update',
  'Save & Start a New Chat, View Saved Chats, and Reset OC have been moved to Chat Archives.':
    'Save & Start a New Chat, View Saved Chats, and Reset OC have been moved to Chat Archives.',
  'Tap anywhere to dismiss': 'Tap anywhere to dismiss',
  'Restore previous progress?': 'Restore previous progress?',
  'Previous character creation progress is available. Restore it before continuing?':
    'Previous character creation progress is available. Restore it before continuing?',
  '[Image · Available in app only]': '[Image · Available in app only]',
  'Sort by': 'Sort by',
  'Content Rating': 'Content Rating',
  Recommended: 'Recommended',
  'Most Interacted': 'Most Interacted',
  'Most Liked': 'Most Liked',
  'Most Favorited': 'Most Favorited',
  'Search characters or creators...': 'Search characters or creators...',
  SFW: 'SFW',
  // ===== Tidal Hearts（6 月活动）详情页 =====
  'Tidal Hearts Character #{{rank}}': 'Character #{{rank}}',
  'Tidal Hearts Creator': 'Creator',
  'Tidal Hearts Sender #{{rank}}': 'Sender #{{rank}}',
  'Send Drinks. Unlock Heart Reveal. Collect Summer Memories.':
    'Send Drinks. Unlock Heart Reveal. Collect Summer Memories.',
  'Increase Heat Level to discover': 'Increase Heat Level to discover',
  'new conversations, hidden feelings, and exclusive rewards.':
    'new conversations, hidden feelings, and exclusive rewards.',
  'Each Drink = 150 EXP': 'Each Drink = 150 EXP',
  "Send Drinks to raise your character's Heat Level and unlock Heart Reveal interactions.":
    "Send Drinks to raise your character's Heat Level and unlock Heart Reveal interactions.",
  Unlocks: 'Unlocks',
  'Heat Level Progression': 'Heat Level Progression',
  'Heart Reveal Feature': 'Heart Reveal Feature',
  '✨ Special Reward': '✨ Special Reward',
  'Reach 500% Heat Level with a character during Week 3 (Jul 10–16) to unlock an exclusive Island Video.':
    'Reach 500% Heat Level with a character during Week 3 (Jul 10–16) to unlock an exclusive Island Video.',
  'Ways to Get Drinks': 'Ways to Get Drinks',
  'First Event Login (2 Free Drinks)': 'First Event Login (2 Free Drinks)',
  'Chat Drops': 'Chat Drops',
  'Night Pass Bundle': 'Night Pass Bundle',
  'Send Drinks Now': 'Send Drinks Now',
  '-Unlock at 20% Heat Level-': '-Unlock at 20% Heat Level-',
  'Reach 20% Heat Level to receive a Heart Reveal invitation in your Inbox. Ask special questions and discover a side of your character you have never seen before.':
    'Reach 20% Heat Level to receive a Heart Reveal invitation in your Inbox. Ask special questions and discover a side of your character you have never seen before.',
  'Reach 20% Heat Level to receive': 'Reach 20% Heat Level to receive',
  'a Heart Reveal invitation in your Inbox.':
    'a Heart Reveal invitation in your Inbox.',
  'Ask special questions and discover a side of your character you have never seen before.':
    'Ask special questions and discover a side of your character you have never seen before.',
  '✨ Log in during the event to receive a free event background.':
    '✨ Log in during the event to receive a free event background.',
  'Purchase the': 'Purchase the',
  '$99.99 Bundle': '$99.99 Bundle',
  'to unlock an': 'to unlock an',
  'exclusive animated background.': 'exclusive animated background.',
  'All unlocked backgrounds will remain in your collection after the event ends.':
    'All unlocked backgrounds will remain in your collection after the event ends.',
  'As Heat Rises': 'As Heat Rises',
  'Unlock deeper conversations': 'Unlock deeper conversations',
  'Reveal hidden feelings': 'Reveal hidden feelings',
  'Receive different answers at different Heat Levels':
    'Receive different answers at different Heat Levels',
  'What Can You Ask?': 'What Can You Ask?',
  'Anything Else On Your Mind': 'Anything Else On Your Mind',
  'Dream Dates': 'Dream Dates',
  'Hidden Secrets': 'Hidden Secrets',
  'Personal Feelings': 'Personal Feelings',
  'Relationship Questions': 'Relationship Questions',
  'Reveal Their Heart': 'Reveal Their Heart',
  'Collect 8+1 Exclusive Snapshots': 'Collect 8+1 Exclusive Snapshots',
  'Every snapshot captures a different side of summer.':
    'Every snapshot captures a different side of summer.',
  "Collect exclusive Polaroids and uncover moments you won't find anywhere else.":
    "Collect exclusive Polaroids and uncover moments you won't find anywhere else.",
  'Collection Includes: 8 Summer scenes + 1 Secret Snapshot':
    'Collection Includes: 8 Summer scenes + 1 Secret Snapshot',
  '✨ Summer Scenes can only be obtained through Chat Drops.':
    '✨ Summer Scenes can only be obtained through Chat Drops.',
  '✨ Unlocked Summer Scenes remain permanently available in your collection after the event ends.':
    '✨ Unlocked Summer Scenes remain permanently available in your collection after the event ends.',
  'Ways to get new Snapshots': 'Ways to get new Snapshots',
  'Extra Shots': 'Extra Shots',
  'Auto-Join: ': 'Auto-Join: ',
  'Send your first Drink or Summer Snapshot to automatically enter the event rankings.':
    'Send your first Drink or Summer Snapshot to automatically enter the event rankings.',
  'Scoring: ': 'Scoring: ',
  'Every Drink and Summer Snapshot sent during the event period will automatically count toward your ranking score.':
    'Every Drink and Summer Snapshot sent during the event period will automatically count toward your ranking score.',
  'Points System:': 'Points System:',
  '🍹 1 Drink = 150 Points': '🍹 1 Drink = 150 Points',
  '📸 1 Summer Snapshot = 20 Points': '📸 1 Summer Snapshot = 20 Points',
  'Final Ranking: ': 'Final Ranking: ',
  'Rankings are determined by the total points earned from Drinks and Summer Snapshots throughout the event.':
    'Rankings are determined by the total points earned from Drinks and Summer Snapshots throughout the event.',
  'Leaderboard Updates: ': 'Leaderboard Updates: ',
  'Character Rankings and Top Sender Rankings are updated daily at 00:00 UTC.':
    'Character Rankings and Top Sender Rankings are updated daily at 00:00 UTC.',
  'Event Rewards': 'Event Rewards',
  '🥇 1st Place ━ 100,000 Gems': '🥇 1st Place ━ 100,000 Gems',
  '🥈 2nd Place ━ 50,000 Gems': '🥈 2nd Place ━ 50,000 Gems',
  '🥉 3rd Place ━ 20,000 Gems': '🥉 3rd Place ━ 20,000 Gems',
  '✨ 4th–10th Place ━ 5,000 Gems': '✨ 4th–10th Place ━ 5,000 Gems',
  '🌟 11th–50th Place ━ 1,000 Gems': '🌟 11th–50th Place ━ 1,000 Gems',
  '🎁 51st–100th Place ━ 500 Gems': '🎁 51st–100th Place ━ 500 Gems',
  'Sending Drinks, taking Polaroids, and Heart Reveals are currently only supported on the mobile app. Download the App to unlock these features and interact with your character!':
    'Sending Drinks, taking Polaroids, and Heart Reveals are currently only supported on the mobile app. Download the App to unlock these features and interact with your character!',
  'Taking Polaroids and Heart Reveals are currently only supported on the mobile app. Download the App to unlock these features and interact with your character!':
    'Taking Polaroids and Heart Reveals are currently only supported on the mobile app. Download the App to unlock these features and interact with your character!',
  'Not Enough Drinks': 'Not Enough Drinks',
  "{{name}}'s glass is empty — top it up to keep going.":
    "{{name}}'s glass is empty — top it up to keep going.",
  'Get More': 'Get More',
  'Sending drinks grows your relationship with {{name}} and unlocks Heart Reveal — an experience only available on the app.':
    'Sending drinks grows your relationship with {{name}} and unlocks Heart Reveal — an experience only available on the app.',
  'Download the App': 'Download the App',
  'Send Anyway': 'Send Anyway',
  // ===== Tidal Hearts 聊天引导遮罩 =====
  'You found a Drink': 'You found a Drink',
  'Each drink gives +150 Relationship EXP and +10% Heat Level. Hit 20% Heat Level to unlock Heart Reveal.\nKeep chatting — Summer Drinks drop randomly and land in your Cocktail Basket, ready to gift to any character you like.\nRunning low? Top up your Cocktail Basket with a gift pack.':
    'Each drink gives +150 Relationship EXP and +10% Heat Level. Hit 20% Heat Level to unlock Heart Reveal.\nKeep chatting — Summer Drinks drop randomly and land in your Cocktail Basket, ready to gift to any character you like.\nRunning low? Top up your Cocktail Basket with a gift pack.',
  'Failed to send gift': 'Failed to send gift',
  // ===== 提现 Withdrawal(由 tipsy-app 移植)=====
  'Withdrawal Details': 'Withdrawal Details',
  'Account Information': 'Account Information',
  'Add Withdrawal Account': 'Add Withdrawal Account',
  'Account is not active': 'Account is not active',
  Bank: 'Bank',
  'Withdrawal Amount': 'Withdrawal Amount',
  'Available Balance': 'Available Balance',
  'Net withdrawal amount': 'Net withdrawal amount',
  'Service fee': 'Service fee',
  'Withdraw Now': 'Withdraw Now',
  'Set Up Account': 'Set Up Account',
  'Withdrawal Account': 'Withdrawal Account',
  'Withdrawal Rules': 'Withdrawal Rules',
  Withdraw: 'Withdraw',
  'Withdrawal request submitted': 'Withdrawal request submitted',
  'The amount exceeds your available balance.':
    'The amount exceeds your available balance.',
  'Withdrawal under review': 'Withdrawal under review',
  'Your withdrawal request is being reviewed. This usually takes 10 business days.':
    'Your withdrawal request is being reviewed. This usually takes 10 business days.',
  'Withdrawal Approved': 'Withdrawal Approved',
  'It may take 2–3 business days for the funds to arrive due to bank processing times.':
    'It may take 2–3 business days for the funds to arrive due to bank processing times.',
  'Withdrawal Date': 'Withdrawal Date',
  'Withdrawal Failed': 'Withdrawal Failed',
  'Your withdrawal was rejected for:': 'Your withdrawal was rejected for:',
  'Withdrawal failed': 'Withdrawal failed',
  'Coins have been returned to your balance.':
    'Coins have been returned to your balance.',
  'Withdrawal Status': 'Withdrawal Status',
  'Unknown Failed': 'Unknown Failed',
  'Transfer to:': 'Transfer to:',
  'Order ID:': 'Order ID:',
  'Set Account': 'Set Account',
  'Select PayPal or a bank card as your withdrawal method. Enter your account details and complete verification.':
    'Select PayPal or a bank card as your withdrawal method. Enter your account details and complete verification.',
  'Submit Request': 'Submit Request',
  'Wire/Bank transfer: $5 fee': 'Wire/Bank transfer: $5 fee',
  'PayPal: $0.70 + 2% fee': 'PayPal: $0.70 + 2% fee',
  'Tax fee': 'Tax fee',
  'Local regulatory tax deduction': 'Local regulatory tax deduction',
  'Exchange rate': 'Exchange rate',
  'Based on real-time market rate': 'Based on real-time market rate',
  Review: 'Review',
  'Each withdrawal request is subject to manual review, including checks for potential violations and infringements, security issues, and other related risks.':
    'Each withdrawal request is subject to manual review, including checks for potential violations and infringements, security issues, and other related risks.',
  Received: 'Received',
  'Funds will arrive in your account within 10 business days.':
    'Funds will arrive in your account within 10 business days.',
  'Withdraw Balance': 'Withdraw Balance',
  'Amount below ${{amount}} minimum withdrawal.':
    'Amount below ${{amount}} minimum withdrawal.',
  'Amount exceeds ${{amount}} maximum withdrawal.':
    'Amount exceeds ${{amount}} maximum withdrawal.',
  'Enter the amount you wish to withdraw and confirm. \nMinimum withdrawal amount: ${{minAmount}}\nMaximum withdrawal amount: ${{maxAmount}}':
    'Enter the amount you wish to withdraw and confirm. \nMinimum withdrawal amount: ${{minAmount}}\nMaximum withdrawal amount: ${{maxAmount}}',
  '(may affect total withdrawal)': '(may affect total withdrawal)',
  Presets: 'Presets',
  Custom: 'Custom',
  'Edit Custom Style': 'Edit Custom Style',
  'New Style': 'New Style',
  Context: 'Context',
  'Name your style, e.g. Playful': 'Name your style, e.g. Playful',
  'Describe how {{char}} should talk to you':
    'Describe how {{char}} should talk to you',
  'Define how characters talk, including tone, mood, and reply length.':
    'Define how characters talk, including tone, mood, and reply length.',
  'Failed to load conversation styles': 'Failed to load conversation styles',
  'Saved successfully': 'Saved successfully',
  'Save failed, please try again': 'Save failed, please try again',
  'Deleted Successfully': 'Deleted Successfully',
  'Delete Conversation Style?': 'Delete Conversation Style?',
  'Characters using this style will switch to Default.':
    'Characters using this style will switch to Default.',
  'Up to 3 custom styles allowed. Delete one to try again.':
    'Up to 3 custom styles allowed. Delete one to try again.',
  'Add new style': 'Add new style',
  'Unsaved Changes': 'Unsaved Changes',
  'You have unsaved changes. Save before leaving?':
    'You have unsaved changes. Save before leaving?',
  'Keep Editing': 'Keep Editing',
  Deleting: 'Deleting',
  'Image & Video Generation': 'Image & Video Generation',
  "Unlike chat messages, Image and Video generation are charged at a flat rate per generation, regardless of your Memory Usage or token count. Each model's Gem cost is shown directly on the model card before you generate.":
    "Unlike chat messages, Image and Video generation are charged at a flat rate per generation, regardless of your Memory Usage or token count. Each model's Gem cost is shown directly on the model card before you generate.",
  'A midsummer memory with {{name}} has been recorded.':
    'A midsummer memory with {{name}} has been recorded.',
  'this character': 'this character',
  'Watch Now': 'Watch Now',
  'Claim Gift': 'Claim Gift',
  'Island Activity': 'Island Activity',
  'Video generation failed. Please claim your gift.':
    'Video generation failed. Please claim your gift.',
  'I confirm that any character I create is depicted as an adult aged 18 or above and does not infringe upon the rights of any third party.':
    'I confirm that any character I create is depicted as an adult aged 18 or above and does not infringe upon the rights of any third party.',
  // ===== Oracles Call（7 月活动 july_tarot）=====
  'Faction Selection Period': 'Faction Selection Period',
  'Event Period': 'Event Period',
  'Game Rules': 'Game Rules',
  '(Each Faction)': '(Each Faction)',
  '(Your Faction)': '(Your Faction)',
  'Faction Standings': 'Faction Standings',
  'Updated daily at 00:00 UTC': 'Updated daily at 00:00 UTC',
  'Earn Contribution': 'Earn Contribution',
  "Every action you take during the event contributes to your faction's total score. Work together with your allies to climb the rankings and claim victory.":
    "Every action you take during the event contributes to your faction's total score. Work together with your allies to climb the rankings and claim victory.",
  'Love Potion': 'Love Potion',
  'Limited Polaroids': 'Limited Polaroids',
  'Tarot Reading': 'Tarot Reading',
  'How To Play': 'How To Play',
  'Join one of three factions, uncover your destiny through tarot, and compete alongside your allies for exclusive rewards.':
    'Join one of three factions, uncover your destiny through tarot, and compete alongside your allies for exclusive rewards.',
  'Each Wish = 80 EXP': 'Each Wish = 80 EXP',
  "Use a Wish to uncover your character's Past, Present, and Future through a three-card tarot reading. Every reading reveals new insights shaped by your shared memories.":
    "Use a Wish to uncover your character's Past, Present, and Future through a three-card tarot reading. Every reading reveals new insights shaped by your shared memories.",
  'Past • Present • Future Reading': 'Past • Present • Future Reading',
  'Relationship Interpretation': 'Relationship Interpretation',
  'Ways to Get Wishes': 'Ways to Get Wishes',
  'First-Day Login': 'First-Day Login',
  'Purchase with Gems (80 Gems)': 'Purchase with Gems (80 Gems)',
  'Read Your Fortune': 'Read Your Fortune',
  'Each Potion = 1 EXP': 'Each Potion = 1 EXP',
  'Send a Love Potion to strengthen your bond with a character and increase your Affinity.':
    'Send a Love Potion to strengthen your bond with a character and increase your Affinity.',
  'Voter Standings': 'Voter Standings',
  'Ways to Get Potions': 'Ways to Get Potions',
  'Event Bundles': 'Event Bundles',
  'Purchase with Gems': 'Purchase with Gems',
  'Send Now': 'Send Now',
  'Medieval Polaroid': 'Medieval Polaroid',
  'Collect 11+1 Exclusive Snapshots': 'Collect 11+1 Exclusive Snapshots',
  "Capture exclusive moments with your favorite characters throughout the event. Every Limited Polaroid you collect contributes to your faction's score while preserving a special memory forever.":
    "Capture exclusive moments with your favorite characters throughout the event. Every Limited Polaroid you collect contributes to your faction's score while preserving a special memory forever.",
  'Collection Includes: 11 Medieval scenes + 1 Secret Snapshot':
    'Collection Includes: 11 Medieval scenes + 1 Secret Snapshot',
  'Medieval Scenes can only be obtained through Chat Drops.':
    'Medieval Scenes can only be obtained through Chat Drops.',
  'Unlocked Medieval Scenes remain permanently available in your collection after the event ends.':
    'Unlocked Medieval Scenes remain permanently available in your collection after the event ends.',
  'Ranking & Reward': 'Ranking & Reward',
  'Auto-Join': 'Auto-Join',
  "Choose a faction to automatically enter your faction's rankings. Your contribution will begin counting immediately after joining.":
    "Choose a faction to automatically enter your faction's rankings. Your contribution will begin counting immediately after joining.",
  Scoring: 'Scoring',
  "Every eligible activity completed during the event contributes to both your personal ranking and your faction's total score.":
    "Every eligible activity completed during the event contributes to both your personal ranking and your faction's total score.",
  'Points System': 'Points System',
  'Love Potion = 1 Point': 'Love Potion = 1 Point',
  'Tarot Reading = 80 Points': 'Tarot Reading = 80 Points',
  'Limited Polaroids = 20 Points': 'Limited Polaroids = 20 Points',
  'Final Ranking': 'Final Ranking',
  'Each faction has its own Top 50 Contributors leaderboard. Rankings are determined by the total Contribution Points earned throughout the event.':
    'Each faction has its own Top 50 Contributors leaderboard. Rankings are determined by the total Contribution Points earned throughout the event.',
  'Faction Victory': 'Faction Victory',
  'At the end of the event, the faction with the highest total Contribution Points will be crowned the winner. All members of the winning faction will receive an exclusive Avatar Frame as a commemorative reward, while Top 50 Contributors from each faction will receive ranking rewards based on their final placement.':
    'At the end of the event, the faction with the highest total Contribution Points will be crowned the winner. All members of the winning faction will receive an exclusive Avatar Frame as a commemorative reward, while Top 50 Contributors from each faction will receive ranking rewards based on their final placement.',
  'Event Rewards(Each Faction)': 'Event Rewards(Each Faction)',
  '🥇 1st': '🥇 1st',
  '🥈 2nd–3rd': '🥈 2nd–3rd',
  '🥉 4th–10th': '🥉 4th–10th',
  '🏅 11th–20th': '🏅 11th–20th',
  '🏅 21st–50th': '🏅 21st–50th',
  '50,000 Gems': '50,000 Gems',
  '20,000 Gems': '20,000 Gems',
  '5,000 Gems': '5,000 Gems',
  '1,000 Gems': '1,000 Gems',
  '500 Gems': '500 Gems',
  'Loading…': 'Loading…',
  'Ranking will be revealed on {{date}}':
    'Ranking will be revealed on {{date}}',
  'Contributor #{{rank}}': 'Contributor #{{rank}}',
  'Faction selection has closed': 'Faction selection has closed',
  'Faction selection has not started yet':
    'Faction selection has not started yet',
  'Failed to join the faction, please try again':
    'Failed to join the faction, please try again',
  'You have joined {{faction}}!': 'You have joined {{faction}}!',
  'Tarot Readings, sending Love Potions, and taking Polaroids are currently only supported on the mobile app. Download the App to unlock these features and interact with your character!':
    'Tarot Readings, sending Love Potions, and taking Polaroids are currently only supported on the mobile app. Download the App to unlock these features and interact with your character!',
  '+1 Point': '+1 Point',
  '+20 Points': '+20 Points',
  '+80 Points': '+80 Points',
  '+1 Contribution Point': '+1 Contribution Point',
  'Your faction cannot be changed once selected. Choose wisely.':
    'Your faction cannot be changed once selected. Choose wisely.',
  'Confirming…': 'Confirming…',
  'Select a faction first': 'Select a faction first',
  Nocturne: 'Nocturne',
  'Demi-Human': 'Demi-Human',
  Aether: 'Aether',
  'Snapshot ?': 'Snapshot ?',
  'Heart record updates in {{time}}': 'Heart record updates in {{time}}',
  'Not Enough Potions': 'Not Enough Potions',
  "You're out of Love Potions! Purchase more for 1 Gem?":
    "You're out of Love Potions! Purchase more for 1 Gem?",
  'You found a Love Potion💗': 'You found a Love Potion💗',
  'A Love Potion has dropped during your conversation!':
    'A Love Potion has dropped during your conversation!',
  "It's now safely stored in your Potion Pouch and can be gifted to any character.":
    "It's now safely stored in your Potion Pouch and can be gifted to any character.",
  '1 potion = 5 EXP': '1 potion = 5 EXP',
  'Your tarot reading is ready': 'Your tarot reading is ready',
  'Out of Free Inspirations': 'Out of Free Inspirations',
  'Subscribe to continue generating inspiration.':
    'Subscribe to continue generating inspiration.',
} as const
